(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["repair-configurator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('repair-inquiry')) {
    customElements.define('repair-inquiry', class RepairInquiry extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.form = this.querySelector('form');
        this.brandInput = this.querySelector('[data-inquiry-brand]');
        this.modelInput = this.querySelector('[data-inquiry-model]');
        this.repairInput = this.querySelector('[data-inquiry-repair]');
        this.emailInput = this.querySelector('[data-inquiry-email]');
        this.emailField = this.querySelector('[data-email-field]');
        this.emailButton = this.querySelector('[data-inquiry-email-submit]');
        this.whatsappButton = this.querySelector('[data-inquiry-whatsapp]');
        this.bodyInput = this.querySelector('[data-inquiry-body]');
        this.contactChoices = Array.from(this.querySelectorAll('[data-contact-choice]'));
        this.sharedInputs = [this.brandInput, this.modelInput, this.repairInput];

        this.contactChoices.forEach((choice) => {
          choice.addEventListener('change', () => this.setContactMode(choice.value));
        });
        [...this.sharedInputs, this.emailInput].forEach((input) => {
          input.addEventListener('input', () => this.clearFieldError(input));
        });
        this.whatsappButton.addEventListener('click', (event) => this.handleWhatsapp(event));
        this.addEventListener('submit', (event) => this.handleEmailSubmit(event), true);

        const selectedChoice = this.contactChoices.find((choice) => choice.checked) || this.contactChoices[0];
        this.setContactMode(selectedChoice.value);

        const success = this.querySelector('[data-inquiry-success]');
        if (success) success.focus();
      }

      setContactMode(mode) {
        const emailMode = mode === 'email';
        this.contactChoices.forEach((choice) => {
          const selected = choice.value === mode;
          choice.checked = selected;
          choice.closest('.repair-inquiry__choice').classList.toggle('is-selected', selected);
        });
        this.emailField.hidden = !emailMode;
        this.emailInput.disabled = !emailMode;
        this.emailInput.required = emailMode;
        this.emailButton.hidden = !emailMode;
        this.whatsappButton.hidden = emailMode;
        if (!emailMode) this.clearFieldError(this.emailInput);
      }

      handleWhatsapp(event) {
        if (!this.validateInputs(this.sharedInputs)) {
          event.preventDefault();
          return;
        }
        this.whatsappButton.href = this.buildWhatsappUrl();
      }

      handleEmailSubmit(event) {
        const mode = this.contactChoices.find((choice) => choice.checked)?.value;
        if (mode !== 'email') {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }

        if (!this.validateInputs([...this.sharedInputs, this.emailInput])) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }

        this.bodyInput.value = this.buildMessage(true);
      }

      validateInputs(inputs) {
        let firstInvalid = null;
        inputs.forEach((input) => {
          if (!this.validateField(input) && !firstInvalid) firstInvalid = input;
        });
        if (firstInvalid) firstInvalid.focus();
        return !firstInvalid;
      }

      validateField(input) {
        const value = input.value.trim();
        let message = '';
        if (!value) {
          message = input === this.emailInput ? this.dataset.emailRequiredError : this.dataset.requiredError;
        } else if (input === this.emailInput && !input.validity.valid) {
          message = this.dataset.emailInvalidError;
        }
        this.setFieldError(input, message);
        return message === '';
      }

      setFieldError(input, message) {
        const wrapper = input.closest('[data-field-wrapper]');
        const error = wrapper.querySelector('[data-field-error]');
        wrapper.classList.toggle('has-error', Boolean(message));
        input.setAttribute('aria-invalid', message ? 'true' : 'false');
        error.textContent = message;
        error.hidden = !message;
      }

      clearFieldError(input) {
        this.setFieldError(input, '');
      }

      resetInquiryState() {
        this.form.reset();
        [...this.sharedInputs, this.emailInput].forEach((input) => this.clearFieldError(input));
        this.bodyInput.value = '';
        this.setContactMode('whatsapp');
      }

      buildMessage(includeEmail) {
        const lines = [
          this.dataset.messageGreeting,
          '',
          this.dataset.messageIntro,
          '',
          `${this.dataset.messageBrand}: ${this.brandInput.value.trim()}`,
          `${this.dataset.messageModel}: ${this.modelInput.value.trim()}`,
          `${this.dataset.messageRepair}: ${this.repairInput.value.trim()}`
        ];
        if (includeEmail) lines.push(`${this.dataset.emailReplyLabel}: ${this.emailInput.value.trim()}`);
        lines.push('', this.dataset.messageOutro);
        return lines.join('\n');
      }

      buildWhatsappUrl() {
        const separator = this.dataset.whatsappUrl.includes('?') ? '&' : '?';
        return `${this.dataset.whatsappUrl}${separator}text=${encodeURIComponent(this.buildMessage(false))}`;
      }
    });
  }

  if (!customElements.get('repair-configurator')) {
    customElements.define('repair-configurator', class RepairConfigurator extends HTMLElement {
      connectedCallback() {
        this.observeIphoneCardContent();
        this.progressSizeObserver?.disconnect();
        const progress = this.querySelector('[data-progress]');
        if (progress) {
          const updateProgressHeight = () => {
            this.style.setProperty('--repair-progress-height', progress.getBoundingClientRect().height + 'px');
          };
          this.progressSizeObserver = new ResizeObserver(updateProgressHeight);
          this.progressSizeObserver.observe(progress);
          updateProgressHeight();
        }
        if (this.dataset.initialized === 'true') {
          // Paket A / F-044 (Review): nach einem Umhaengen im Dokument den Verlaufs-Empfaenger wieder anmelden
          // (disconnectedCallback hat ihn entfernt; dieselbe Funktion wird nie doppelt angemeldet).
          if (this.handlePopState) window.addEventListener('popstate', this.handlePopState);
          return;
        }
        this.dataset.initialized = 'true';

        this.data = this.parseJson('[data-repair-configurator-data]', { repairs: [], ui: {} });
        this.prices = {};
        this.priceCache = {};
        this.managedPriceCache = {};
        this.managedDisplayNames = {};
        this.managedDescriptions = {};
        this.priceRequestId = 0;
        this.commerceProduct = null;
        this.commerceCache = {};
        this.commerceRequestId = 0;
        this.paymentButtonCache = {};
        this.paymentButtonRequestId = 0;
        this.purchaseVariant = null;
        this.brand = '';
        this.brandId = '';
        this.dynamicOptions = false;
        this.currentOptions = [];
        this.brandButtons = Array.from(this.querySelectorAll('[data-brand-id]'));
        this.models = Array.from(this.querySelectorAll('[data-model-id]')).map((button) => ({
          id: button.dataset.modelId,
          name: button.dataset.modelName,
          brandId: button.dataset.modelBrand,
          series: button.dataset.modelSeriesKey,
          button
        }));
        this.repairButtons = Array.from(this.querySelectorAll('[data-repair-id]'));
        this.optionContainer = this.querySelector('[data-options]');
        this.standardFlow = this.querySelector('[data-standard-flow]');
        this.otherFlow = this.querySelector('[data-other-flow]');
        this.brandPanel = this.querySelector('[data-brand-panel]');
        this.modelHeading = this.querySelector('[data-model-heading]');
        this.modelGroup = this.querySelector('[data-model-group]');
        this.flowPanels = Array.from(this.querySelectorAll('[data-flow-step]'));
        this.flowSummary = this.querySelector('[data-flow-summary]');
        this.progress = this.querySelector('[data-progress]');
        this.progressButtons = Array.from(this.querySelectorAll('[data-progress-step]'));
        this.modelSearch = this.querySelector('[data-model-search]');
        this.modelToggle = this.querySelector('[data-model-toggle]');
        this.modelStatus = this.querySelector('[data-model-status]');
        this.modelInquiry = this.querySelector('[data-model-inquiry]'); // Block B (F-04)
        this.modelSeries = Array.from(this.querySelectorAll('[data-model-series]'));
        this.optionContinue = this.querySelector('[data-option-continue]');
        this.mobileSummary = this.querySelector('[data-mobile-summary]');
        this.mobileSummaryAction = this.querySelector('[data-mobile-summary-action]');
        this.repairContext = this.querySelector('[data-repair-context]');
        // T2 / F-008: Stoerungshinweis der Preisabfrage (je eine Kopie in den Schritt-Karten 3 bis 5).
        this.priceFaultNodes = Array.from(this.querySelectorAll('[data-price-fault]'));
        this.priceFault = false;
        this.priceRetryFocus = false;
        this.priceUrls = {
          apple: this.dataset.applePricesUrl,
          samsung: this.dataset.samsungPricesUrl,
          google: this.dataset.googlePricesUrl
        };
        this.selectedModel = null;
        this.selectedRepair = null;
        this.selectedOption = null;
        this.activeStep = 1;
        this.modelListExpanded = false;
        this.pricesReady = false;
        this.interactionGeneration = 0;

        this.brandButtons.forEach((button) => {
          button.addEventListener('click', (event) => this.selectBrand(button.dataset.brandId, { focusSearch: event.detail === 0 }));
        });
        this.models.forEach((model) => {
          model.button.addEventListener('click', () => this.selectModel(model));
        });
        this.repairButtons.forEach((button) => {
          button.addEventListener('click', () => this.selectRepair(button.dataset.repairId));
        });
        this.progressButtons.forEach((button) => {
          button.addEventListener('click', (event) => this.openStep(Number(button.dataset.progressStep), { focusSearch: event.detail === 0 }));
        });
        this.modelSearch?.addEventListener('input', () => this.applyModelVisibility());
        this.modelInquiry?.addEventListener('click', () => this.openModelInquiry()); // Block B (F-04)
        this.modelToggle?.addEventListener('click', () => {
          this.modelListExpanded = !this.modelListExpanded;
          this.applyModelVisibility();
        });
        this.optionContinue?.addEventListener('click', () => {
          if (!this.canContinueWithoutOption()) return;
          this.render();
          this.openStep(5);
        });
        this.mobileSummaryAction?.addEventListener('click', (event) => {
          // T2 (19.09.2026, Gegenpruefung): Laeuft in der Zusammenfassung gerade ein Wiederholungsversuch der
          // Preisabfrage, bleibt sie stehen - sonst spraenge "Zur Buchung" fuer wenige Sekunden zur Qualitaetswahl zurueck.
          if (this.activeStep === 5 && !this.pricesReady) return;
          const nextStep = this.nextRequiredStep();
          // Patch 3 (18.09.2026, M4): Steht Schritt 5 schon offen, fuehrt "Zur Buchung" zum
          // Aktionsbereich statt denselben Schritt erneut zu oeffnen.
          if (nextStep === 5 && this.activeStep === 5) {
            this.revealPurchaseActions();
            return;
          }
          // T2/T4 (19.09.2026, Gegenpruefung): Ohne Optionskarten (Reparatur ohne Festpreis oder Stoerung der
          // Preisabfrage) oeffnete "Zur Buchung" eine nicht aufgebaute Zusammenfassung - Preis "-", gesperrter Knopf,
          // kein Anfrageweg, Texte der vorherigen Auswahl. Wie beim Knopf "Weiter zur Zusammenfassung" wird deshalb
          // vorher aufgebaut. Der Schrittwechsel selbst (openStep) bleibt unveraendert.
          if (nextStep === 5) this.render();
          this.openStep(nextStep, { focusSearch: event.detail === 0 });
        });
        this.addEventListener('repair-handover:reveal', () => this.revealHandover());
        // Express im Konfigurator (27.09.2026): Knoepfe erst nach der Wahl der Uebergabeart (syncPaymentButton).
        this.addEventListener('change', (event) => {
          if (event.target?.closest?.('iv-repair-handover')) this.syncPaymentButton();
        });
        this.querySelector('[data-summary-cta]')?.addEventListener('click', (event) => this.handleSummaryCta(event));
        this.priceFaultNodes.forEach((node) => {
          node.querySelector('[data-price-fault-retry]')?.addEventListener('click', () => this.retryPrices());
        });

        // Paket A / F-044 (27.09.2026): Verlaufseintraege je Schritt (writeHistory) nur auf der Reparaturseite selbst.
        // Eingebettet auf der Startseite (data-collection-tabs-embed) aendern die Reiter die Adresse ebenfalls - dort
        // bleibt es beim bisherigen replaceState ohne Verlaufseintrag.
        this.historyEnabled = !this.hasAttribute('data-collection-tabs-embed');
        this.historyReady = false;
        const requestedBrand = new URL(window.location.href).searchParams.get('brand')?.toLowerCase();
        const inquiryResult = this.otherFlow.querySelector('.repair-inquiry__notification');
        this.resetFlow();
        if (inquiryResult) {
          this.selectBrand('other', { force: true, updateUrl: false, shouldScroll: false, preserveInquiry: true });
          inquiryResult.setAttribute('tabindex', '-1');
          inquiryResult.focus({ preventScroll: true });
        } else if (['apple', 'samsung', 'google', 'other'].includes(requestedBrand)) {
          this.selectBrand(requestedBrand, { force: true, updateUrl: false, shouldScroll: false });
        }
        this.correctInitialScroll(inquiryResult);
        // Paket A / F-044: den Einstiegseintrag mit dem Anfangszustand stempeln; ab jetzt legt jeder Schrittwechsel einen
        // Eintrag an, und Browser-Zurueck (auch die Wischgeste) stellt den vorherigen Schritt wieder her.
        this.writeHistory('replace');
        this.historyReady = true;
        this.handlePopState = (event) => {
          const state = event.state && event.state.ivRepair;
          if (!this.historyEnabled || !state) return;
          // Review 27.09.: Richtung aus der laufenden Nummer der Eintraege. Aendert ein Eintrag nichts Sichtbares (z. B. nach
          // Neuladen: alte Eintraege "Schritt 4" ohne gewaehltes Modell), wird er in derselben Richtung uebersprungen -
          // sonst blieben mehrere Zurueck-Gesten ohne Wirkung. Ohne sichere Richtung (fehlende/gleiche Nummer) nie springen;
          // innerhalb einer Sprungkette nie die Richtung umkehren und hoechstens 8 Spruenge - so kann nichts hin und her pendeln.
          const idx = Number.isInteger(state.idx) ? state.idx : null;
          const bekannt = Number.isInteger(this.historyIndex);
          const richtung = idx === null || !bekannt || idx === this.historyIndex ? 0 : (idx < this.historyIndex ? -1 : 1);
          if (idx !== null) this.historyIndex = idx;
          const geaendert = this.restoreHistoryState(state);
          const kette = this.historySkip;
          this.historySkip = null;
          if (geaendert || richtung === 0) return;
          if (kette && (kette.richtung !== richtung || kette.anzahl >= 8)) return;
          this.historySkip = { richtung, anzahl: (kette ? kette.anzahl : 0) + 1 };
          window.history.go(richtung);
        };
        window.addEventListener('popstate', this.handlePopState);
      }

      disconnectedCallback() {
        this.iphoneContentObserver?.disconnect();
        this.progressSizeObserver?.disconnect();
        this.invalidateDeferredInteraction();
        if (this.handlePopState) window.removeEventListener('popstate', this.handlePopState);
      }

      observeIphoneCardContent() {
        this.iphoneContentObserver?.disconnect();
        const cards = this.querySelectorAll('.repair-configurator__model-grid--iphone-portrait > button[data-model-brand="apple"]');
        if (!cards.length) return;
        this.iphoneContentObserver = new ResizeObserver((entries) => {
          const changedCards = new Set(entries.map(({ target }) => target.closest('[data-model-id]')));
          const updates = Array.from(changedCards, (card) => {
            const phoneHeight = card.querySelector('.repair-configurator__phone').getBoundingClientRect().height;
            const nameHeight = card.querySelector('.repair-configurator__model-name').getBoundingClientRect().height;
            if (!phoneHeight || !nameHeight) return null;
            return { card, gap: 4 + (84 - phoneHeight) / 2 + (30 - nameHeight) / 2 };
          });
          updates.forEach((update) => {
            if (!update) return;
            update.card.style.setProperty('--iphone-content-gap', `${update.gap}px`);
            update.card.classList.add('is-content-centered');
          });
        });
        cards.forEach((card) => {
          this.iphoneContentObserver.observe(card.querySelector('.repair-configurator__phone'));
          this.iphoneContentObserver.observe(card.querySelector('.repair-configurator__model-name'));
        });
      }

      // Paket A / F-044 (27.09.2026): Schritt und Marke im Browser-Verlauf.
      // mode: 'push' (neuer Eintrag, nach Kundenaktion), 'replace' (aktuellen Eintrag aktualisieren), 'none'.
      writeHistory(mode = 'replace', url = '') {
        if (mode === 'none') return;
        if (!this.historyEnabled) {
          // Startseite: unveraendert wie bisher - nur die Adresse, kein Verlaufseintrag.
          if (url) window.history.replaceState({}, '', url);
          return;
        }
        const target = url || window.location.href;
        const next = { step: this.activeStep, brand: this.brandId || '' };
        const current = window.history.state && window.history.state.ivRepair;
        if (mode === 'push' && current && current.step === next.step && current.brand === next.brand && target === window.location.href) return;
        // Laufende Nummer je Eintrag (Richtung bei Zurueck/Vor, siehe handlePopState); ersetzte Eintraege behalten ihre.
        if (mode === 'push') {
          this.historyIndex = (Number.isInteger(this.historyIndex) ? this.historyIndex : 0) + 1;
          window.history.pushState({ ivRepair: { ...next, idx: this.historyIndex } }, '', target);
          return;
        }
        // Eintraege ohne eigene Nummer (erster Aufruf, Sprungmarken oder Fremdeintraege, die beim Neuladen gestempelt werden)
        // bekommen keine: ihre Lage im Verlauf ist unbekannt, sie liefern nie eine Richtung und werden nie uebersprungen.
        const idx = current && Number.isInteger(current.idx) ? current.idx : null;
        this.historyIndex = idx;
        const base = window.history.state && typeof window.history.state === 'object' ? window.history.state : {};
        window.history.replaceState({ ...base, ivRepair: { ...next, idx } }, '', target);
      }

      // Paket A / F-044: Browser-Zurueck/-Vor. Die aktuelle Auswahl bleibt erhalten; geoeffnet wird der Schritt des
      // Eintrags, hoechstens aber der naechste noch fehlende Schritt. Eintraege ohne Marke = Ausgangszustand.
      // Rueckgabe: true, wenn sich Schritt oder Marke sichtbar geaendert haben (sonst ueberspringt handlePopState den Eintrag).
      restoreHistoryState({ step, brand } = {}) {
        const vorher = `${this.activeStep}|${this.brandId}|${this.brandPanel.hidden}`;
        if (!['apple', 'samsung', 'google', 'other'].includes(brand)) {
          if (this.brandId) this.resetFlow();
          if (this.progress) this.progress.hidden = false;
          return `${this.activeStep}|${this.brandId}|${this.brandPanel.hidden}` !== vorher;
        }
        if (brand !== this.brandId) {
          // Review 27.09.: preserveInquiry - ein ausgefuelltes Anfrageformular bleibt bei Zurueck/Vor erhalten.
          this.selectBrand(brand, { force: true, updateUrl: false, shouldScroll: false, historyMode: 'none', preserveInquiry: true });
        }
        if (brand !== 'other') {
          const target = Math.max(1, Math.min(Number(step) || 1, this.nextRequiredStep()));
          this.openStep(target, { historyMode: 'none' });
        }
        return `${this.activeStep}|${this.brandId}|${this.brandPanel.hidden}` !== vorher;
      }

      // Paket A / F-021 (27.09.2026): Einstieg ueber "Modell nicht dabei?" - die gewaehlte Marke bleibt markiert und die
      // Ueberschrift spricht nicht von "weiteren Herstellern". Ohne brandId gilt wieder "Weitere Hersteller" samt
      // urspruenglicher Ueberschrift.
      markInquiryBrand(brandId) {
        if (this.brandId !== 'other') return;
        const markId = brandId || 'other';
        this.brandButtons.forEach((button) => {
          const selected = button.dataset.brandId === markId;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        const heading = this.otherFlow?.querySelector('repair-inquiry .repair-configurator__header h2');
        if (!heading) return;
        if (!heading.dataset.defaultText) heading.dataset.defaultText = heading.textContent;
        heading.textContent = brandId ? 'Reparatur für dein Modell anfragen' : heading.dataset.defaultText;
      }

      // Paket A / F-021: Nach "Modell nicht dabei?" Formularueberschrift UND erstes leeres Feld zeigen. Vorher fuhr die
      // Ansicht nur so weit, bis die Ueberschrift am unteren Bildrand auftauchte - mobil lagen alle Felder darunter.
      // Passen beide nicht zugleich ins Bild, hat das Feld Vorrang (dort steht der Fokus).
      revealInquiry(inquiry, field, smooth) {
        const header = inquiry.querySelector('.repair-configurator__header') || inquiry;
        const viewport = this.viewportBounds();
        const gap = this.scrollGap();
        const usableTop = this.stepTopReserve(inquiry) + gap;
        const usableBottom = viewport.bottom - this.bottomOverlayHeight() - gap;
        const headerTop = header.getBoundingClientRect().top;
        const fieldBottom = (field || header).getBoundingClientRect().bottom;
        let delta = fieldBottom > usableBottom ? fieldBottom - usableBottom : 0;
        if (headerTop - delta < usableTop) {
          const headerDelta = headerTop - usableTop;
          if (fieldBottom - headerDelta <= usableBottom) delta = headerDelta;
        }
        if (Math.abs(delta) <= 2) return;
        const maximum = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        this.scrollWindowTo(Math.max(0, Math.min(maximum, Math.round(window.scrollY + delta))), smooth);
      }

      resetFlow() {
        this.invalidateDeferredInteraction();
        this.querySelector('iv-repair-handover')?.reset?.();
        this.activeStep = 1;
        this.priceRequestId += 1;
        this.commerceRequestId += 1;
        this.paymentButtonRequestId += 1;
        this.brand = '';
        this.brandId = '';
        this.dynamicOptions = false;
        this.selectedModel = null;
        this.selectedRepair = null;
        this.selectedOption = null;
        this.currentOptions = [];
        this.prices = {};
        this.pricesReady = false;
        this.priceRetryFocus = false;
        this.setPriceFault(false); // T2: ohne gewaehlte Marke gibt es keine Preisabfrage und keinen Stoerungshinweis
        this.commerceProduct = null;
        this.purchaseVariant = null;
        this.brandButtons.forEach((button) => {
          button.classList.remove('is-selected');
          button.setAttribute('aria-pressed', 'false');
        });
        this.models.forEach((model) => {
          model.button.hidden = true;
          model.button.classList.remove('is-selected');
          model.button.setAttribute('aria-pressed', 'false');
        });
        this.modelSeries.forEach((series) => { series.hidden = true; });
        this.repairButtons.forEach((button) => {
          button.classList.remove('is-selected');
          button.setAttribute('aria-pressed', 'false');
        });
        this.optionContainer.replaceChildren();
        if (this.modelSearch) this.modelSearch.value = '';
        this.modelListExpanded = false;
        this.standardFlow.hidden = true;
        this.otherFlow.hidden = true;
        this.brandPanel.hidden = false;
        this.flowPanels.forEach((panel) => { panel.hidden = true; });
        if (this.flowSummary) this.flowSummary.hidden = true;
        this.setText('[data-summary-brand]', '—');
        this.setText('[data-summary-model]', '—');
        this.setText('[data-summary-repair]', '—');
        this.setText('[data-summary-option]', '—');
        this.setText('[data-summary-price]', '—');
        this.setCtaMode('incomplete');
        this.syncMobileSummary();
        this.updateProgress(1);
      }

      invalidateDeferredInteraction() {
        this.interactionGeneration += 1;
        this.deferredInteractionController?.abort();
      }

      watchDeferredInteraction() {
        const controller = new AbortController();
        this.deferredInteractionController = controller;
        const invalidate = () => this.invalidateDeferredInteraction();
        ['pointerdown', 'touchstart', 'wheel', 'keydown', 'click', 'input'].forEach((type) => {
          window.addEventListener(type, invalidate, { capture: true, passive: true, signal: controller.signal });
        });
        return { generation: this.interactionGeneration, controller, focus: document.activeElement };
      }

      openStep(step, { shouldScroll = true, focusSearch = false, historyMode = this.historyReady ? 'push' : 'replace' } = {}) {
        if (!Number.isInteger(step) || step < 1 || step > 5) return;
        if (step >= 2 && !this.brandId) return;
        if (step >= 3 && !this.selectedModel) return;
        if (step >= 4 && !this.selectedRepair) return;
        if (step === 5 && !this.isSelectionComplete()) return;

        this.invalidateDeferredInteraction();
        this.activeStep = step;
        if (this.repairContext) {
          // Gewähltes Modell bleibt in Schritt 3 sichtbar - gleiche
          // Kontextzeile wie in Schritt 4 (data-option-context).
          this.repairContext.hidden = !this.selectedModel;
          this.repairContext.textContent = this.selectedModel ? this.selectedModel.name : '';
        }
        const usesInquiry = this.brandId === 'other';
        this.progress.hidden = usesInquiry;
        this.brandPanel.hidden = step !== 1 && !usesInquiry;
        this.standardFlow.hidden = step === 1 || usesInquiry;
        this.otherFlow.hidden = !usesInquiry;
        this.standardFlow.classList.toggle('is-summary-step', step === 5);
        this.flowPanels.forEach((panel) => {
          panel.hidden = Number(panel.dataset.flowStep) !== step;
        });
        if (this.flowSummary) this.flowSummary.hidden = step !== 5;
        this.updateProgress(step);
        this.syncMobileSummary();
        if (step === 5) this.syncPaymentButton(); // Express: Einsetzen, sobald die Zusammenfassung sichtbar ist
        this.writeHistory(historyMode); // Paket A / F-044

        // Block B (20.09.2026, A11Y-01): Der eben benutzte Knopf liegt nach dem Schrittwechsel in einer verborgenen Karte - der
        // Tastaturfokus fiele auf die Seite zurueck. Ab Schritt 3 wandert er deshalb auf die Ueberschrift der neuen Karte (ohne Scrollen).
        if (step >= 3) {
          const active = document.activeElement;
          const lost = !active || active === document.body || (this.contains(active) && Boolean(active.closest('[hidden]')));
          const heading = lost ? this.flowPanels.find((panel) => Number(panel.dataset.flowStep) === step)?.querySelector('h2') : null;
          if (heading) {
            heading.setAttribute('tabindex', '-1');
            heading.focus({ preventScroll: true });
          }
        }

        if (!shouldScroll) return;
        const target = step === 1
          ? this.brandPanel
          : step === 5
            ? this.flowPanels.find((panel) => Number(panel.dataset.flowStep) === 5)
            : this.flowPanels.find((panel) => Number(panel.dataset.flowStep) === step);
        if (!target) return;
        const stepRequest = this.watchDeferredInteraction();
        window.requestAnimationFrame(() => window.requestAnimationFrame(() => {
          if (stepRequest.generation !== this.interactionGeneration || this.activeStep !== step
            || !this.isConnected || !target.getClientRects().length) {
            stepRequest.controller.abort();
            return;
          }
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.alignViewport(target, step, { smooth: !reduceMotion });
          if (step === 2 && focusSearch) {
            if (this.modelSearch?.getClientRects().length
              && (document.activeElement === stepRequest.focus || document.activeElement === document.body)) {
              this.modelSearch.focus({ preventScroll: true });
            }
          }
          stepRequest.controller.abort();
        }));
      }

      viewportBounds() {
        const viewport = window.visualViewport;
        const top = viewport?.offsetTop || 0;
        const left = viewport?.offsetLeft || 0;
        const height = viewport?.height || window.innerHeight;
        const width = viewport?.width || window.innerWidth;
        return { top, left, bottom: top + height, right: left + width, height };
      }

      scrollGap() {
        return parseFloat(window.getComputedStyle(document.documentElement).fontSize) || 16;
      }

      bottomOverlayHeight() {
        const bar = this.mobileSummary;
        if (!bar || bar.hidden) return 0;
        const style = window.getComputedStyle(bar);
        if (style.display === 'none' || style.visibility === 'hidden' || style.position !== 'fixed') return 0;
        const viewport = this.viewportBounds();
        const rect = bar.getBoundingClientRect();
        if (rect.right <= viewport.left || rect.left >= viewport.right || rect.bottom <= viewport.top) return 0;
        return Math.max(0, viewport.bottom - Math.max(viewport.top, rect.top));
      }

      stepFocusBottom(target, step) {
        const rect = target.getBoundingClientRect();
        const selectors = {
          1: '[data-brand-id]',
          2: '[data-model-id]:not([hidden])',
          3: '[data-repair-id]',
          4: '[data-option-id]',
          5: '[data-detail-intro]'
        };
        const focus = Array.from(target.querySelectorAll(selectors[step] || 'h2'))
          .find((element) => element.getClientRects().length && element.getBoundingClientRect().height > 0);
        const focusRect = focus ? focus.getBoundingClientRect() : null;
        if (focusRect && focusRect.height > 0) return Math.min(rect.bottom, focusRect.bottom);
        const heading = target.querySelector('.repair-configurator__step-heading, .ivoodoo-selection-heading, h2');
        return heading?.getBoundingClientRect().bottom || rect.bottom;
      }

      scrollWindowTo(top, smooth) {
        if (smooth) {
          window.scrollTo({ top, left: window.scrollX, behavior: 'smooth' });
          return;
        }
        // Sofortiger Sprung ohne Animation - unabhaengig von html { scroll-behavior: smooth }.
        const root = document.documentElement;
        const previous = root.style.scrollBehavior;
        root.style.scrollBehavior = 'auto';
        window.scrollTo(window.scrollX, top);
        root.style.scrollBehavior = previous;
      }

      stepTopReserve(target) {
        let top = this.stepHeaderBottom();
        if (!this.progress || this.progress.hidden || !this.progress.getClientRects().length) return top;
        const style = window.getComputedStyle(this.progress);
        const rect = this.progress.getBoundingClientRect();
        const targetRect = target.getBoundingClientRect();
        if (rect.right <= targetRect.left || rect.left >= targetRect.right) return top;
        if (style.position === 'fixed') top = Math.max(top, rect.bottom);
        // Paket A / F-047 (27.09.2026): Die klebende Leiste (nur Handy) immer mit ihrer Klebeposition einrechnen.
        // Vorher zaehlte nur ihre momentane Lage - stand sie beim Schrittwechsel aus tiefer Scrollposition ausserhalb
        // ihres Klebebereichs, reservierte die Rechnung nur die Kopfzeile, und die Leiste verdeckte danach die Ueberschrift.
        // Die Leiste steht im Dokument vor allen Schritten; am Ziel klebt sie deshalb (oder liegt ueber dem Schritt).
        if (style.position === 'sticky' && style.top !== 'auto') {
          top = Math.max(top, parseFloat(style.top) + rect.height);
        }
        return top;
      }

      stepHeaderBottom() {
        const header = document.querySelector('theme-header');
        const wrapper = header?.closest('.header-section') || header;
        const viewport = this.viewportBounds();
        if (!header || !wrapper || !header.getClientRects().length) return viewport.top;
        const style = window.getComputedStyle(wrapper);
        if (style.position !== 'sticky' && style.position !== 'fixed') return viewport.top;
        const rect = header.getBoundingClientRect();
        if (style.visibility === 'hidden' || rect.right <= viewport.left || rect.left >= viewport.right) return viewport.top;
        return Math.max(viewport.top, Math.min(viewport.bottom, rect.bottom));
      }

      alignStepViewport(target, step, { smooth = true } = {}) {
        if (!target?.getClientRects().length) return;
        const viewport = this.viewportBounds();
        const gap = this.scrollGap();
        const usableTop = this.stepTopReserve(target) + gap;
        const usableBottom = viewport.bottom - this.bottomOverlayHeight() - gap;
        if (usableBottom <= usableTop) return;
        const rect = target.getBoundingClientRect();
        const focusBottom = this.stepFocusBottom(target, step);
        let delta = 0;
        if (rect.top < usableTop - 2) {
          delta = rect.top - usableTop;
        } else if (focusBottom > usableBottom + 2) {
          delta = Math.min(focusBottom - usableBottom, Math.max(0, rect.top - usableTop));
        }
        const maximum = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        const next = Math.max(0, Math.min(maximum, Math.round(window.scrollY + delta)));
        if (Math.abs(next - window.scrollY) <= 2) return;
        this.scrollWindowTo(next, smooth);
      }

      alignViewport(target, step, { smooth = true, onlyIfHeadingHidden = false } = {}) {
        if (!target || !target.getClientRects().length) return;
        // Patch 1 (18.09.2026): normale Schrittwechsel laufen ueber die Geometrie des Schritts.
        // Der Zweig darunter bleibt fuer Erstaufruf, Sprungmarke und correctInitialScroll.
        if (!onlyIfHeadingHidden) {
          this.alignStepViewport(target, step, { smooth });
          return;
        }
        const headerBlock = this.querySelector('.repair-configurator__header');
        const heading = headerBlock ? headerBlock.querySelector('h1, h2') : null;
        // Schutz: eingebettet auf der Startseite ist der Kopfblock per CSS ausgeblendet
        // (collection-tabs.css). Ohne Layout-Rechteck liefert die Rechnung unten Nullwerte und
        // wuerde die Seite bei jedem Aufruf um Kopfzeilenhoehe + 8 px nach oben ziehen.
        if (!heading || !heading.getClientRects().length) return;
        const scrollY = window.scrollY;
        const viewport = this.viewportBounds().bottom;
        const stickyTop = this.stepHeaderBottom();
        const gapTop = 16;      // Luft zwischen Sticky-Header und Kopfblock (Eyebrow)
        const gapHeading = 8;   // Mindestluft zwischen Sticky-Header und Hauptueberschrift
        const gapBottom = 24;   // Luft unter der ersten Auswahlreihe des naechsten Schritts
        const tolerance = 2;
        const blockTop = headerBlock.getBoundingClientRect().top + scrollY;
        const headingTop = heading.getBoundingClientRect().top + scrollY;
        const focusBottom = this.stepFocusBottom(target, step) + scrollY;
        // Obergrenzen: bis hierhin darf gescrollt werden, ohne dass die Ueberschrift
        // (hart) bzw. der komplette Kopfblock (weich) unter den Sticky-Header rutscht.
        const upperHard = Math.max(0, Math.floor(headingTop - stickyTop - gapHeading));
        const upperSoft = Math.max(0, Math.min(upperHard, Math.floor(blockTop - stickyTop - gapTop)));
        // Untergrenze: ab hier ist der Fokusbereich des naechsten Schritts sichtbar.
        const lower = Math.max(0, Math.ceil(focusBottom + gapBottom - (viewport - this.bottomOverlayHeight())));
        let next = null;
        if (scrollY > upperHard + tolerance) {
          // Ueberschrift ist verdeckt: nach oben, bevorzugt so, dass der ganze Kopfblock
          // sichtbar ist - sofern der naechste Schritt dabei im Bild bleibt.
          next = upperSoft >= lower ? upperSoft : upperHard;
        } else if (!onlyIfHeadingHidden && scrollY < lower - tolerance) {
          // Naechster Schritt ist noch nicht ausreichend sichtbar: nur so weit nach
          // unten wie noetig, nie ueber die harte Grenze hinaus.
          next = Math.min(lower, upperHard);
        }
        if (next === null || Math.abs(next - scrollY) <= tolerance) return;
        this.scrollWindowTo(next, smooth);
      }

      // Beim Oeffnen ueber eine Sprungmarke (#RepairConfigurator-..., wie sie updateUrl
      // setzt) legt der Browser den Abschnitt buendig an den oberen Rand, sodass die
      // Ueberschrift unter dem Sticky-Header liegt. Nach dem Laden auf denselben
      // Einstieg mit Einleitung korrigieren - ohne Animation und nur, wenn
      // die Ueberschrift tatsaechlich verdeckt ist.
      correctInitialScroll(inquiryResult = null) {
        if (!inquiryResult && (!this.id || window.location.hash !== '#' + this.id)) return;
        const initialRequest = this.watchDeferredInteraction();
        const initialHash = window.location.hash;
        const align = () => {
          if (initialRequest.generation !== this.interactionGeneration || !this.isConnected) return;
          if (window.location.hash !== initialHash) return;
          if (inquiryResult && this.brandId === 'other') {
            this.alignStepViewport(inquiryResult, 1, { smooth: false });
            return;
          }
          if (this.brandId === 'other') return;
          const step = this.activeStep;
          const target = step === 1
            ? this.brandPanel
            : this.flowPanels.find((panel) => Number(panel.dataset.flowStep) === step);
          if (target) this.alignViewport(target, step, { smooth: false, onlyIfHeadingHidden: true });
        };
        const afterLoad = () => {
          let previousY = window.scrollY;
          let stableFrames = 0;
          const settle = () => {
            if (initialRequest.generation !== this.interactionGeneration || !this.isConnected) {
              initialRequest.controller.abort();
              return;
            }
            stableFrames = Math.abs(window.scrollY - previousY) <= 0.5 ? stableFrames + 1 : 0;
            previousY = window.scrollY;
            if (stableFrames < 3) {
              window.requestAnimationFrame(settle);
              return;
            }
            align();
            initialRequest.controller.abort();
          };
          window.requestAnimationFrame(settle);
        };
        if (document.readyState === 'complete') afterLoad();
        else window.addEventListener('load', afterLoad, { once: true, signal: initialRequest.controller.signal });
      }

      updateProgress(activeStep = this.activeStep) {
        const completion = {
          1: Boolean(this.brandId),
          2: Boolean(this.selectedModel),
          3: Boolean(this.selectedRepair),
          4: this.isSelectionComplete()
        };
        this.progressButtons.forEach((button) => {
          const step = Number(button.dataset.progressStep);
          const enabled = step === 1
            || (step === 2 && completion[1])
            || (step === 3 && completion[2])
            || (step === 4 && completion[3]);
          button.disabled = !enabled;
          button.classList.toggle('is-complete', completion[step]);
          if (step === Math.min(activeStep, 4)) button.setAttribute('aria-current', 'step');
          else button.removeAttribute('aria-current');
        });
      }

      // Zeigt den Kauf-/Anfragebereich im freien Bereich zwischen Kopfzeile (bzw. klebender
      // Fortschrittsleiste) und der fixierten Zusammenfassungsleiste. Eine einzige Scrollaktion;
      // ist der Bereich schon sichtbar, passiert nichts.
      revealPurchaseActions() {
        const actions = this.querySelector('[data-purchase-actions]');
        if (!actions || !actions.getClientRects().length) return;
        const panel = this.flowPanels.find((entry) => Number(entry.dataset.flowStep) === 5) || actions;
        const scrollY = window.scrollY;
        const tolerance = 2;
        const gap = 16;
        const usableTop = this.stepTopReserve(panel) + this.scrollGap();
        const usableBottom = this.viewportBounds().bottom - this.bottomOverlayHeight();
        const rect = actions.getBoundingClientRect();
        let next = null;
        if (Math.round(rect.bottom + gap) > usableBottom) {
          const downNeeded = Math.round(rect.bottom + gap - usableBottom);
          const room = Math.max(0, Math.round(rect.top - usableTop));
          if (room > tolerance) next = scrollY + Math.min(downNeeded, room);
        } else if (Math.round(rect.top) < usableTop - tolerance) {
          next = scrollY - Math.round(usableTop - rect.top);
        }
        if (next === null) return;
        next = Math.max(0, next);
        if (Math.abs(next - scrollY) <= tolerance) return;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.scrollWindowTo(next, !reduceMotion);
      }

      // Nachtrag 19.09.2026 (Freigabe Yunus): Schlaegt "In den Warenkorb" fehl, steht die Meldung UNTER dem Buchungsknopf.
      // Ist die mitlaufende Leiste sichtbar (Handy, seit T4 auch Tablet), lag die Meldung nach "Zur Buchung" teilweise
      // dahinter. Nur in diesem Fehlerfall und nur bei sichtbarer Leiste wird einmal so weit gescrollt, dass Meldung und
      // Telefonweg frei ueber der Leiste stehen - nie weiter, als der Buchungsknopf unter dem Kopfbereich sichtbar bleibt.
      // Die Schrittwechsel und "Zur Buchung" (revealPurchaseActions) bleiben unveraendert.
      revealCartError() {
        const overlay = this.bottomOverlayHeight();
        if (!overlay) return;
        const status = this.querySelector('[data-summary-cta-status]');
        const cta = this.querySelector('[data-summary-cta]');
        if (!status || status.hidden || !status.getClientRects().length || !cta || !cta.getClientRects().length) return;
        const phone = this.querySelector('[data-summary-phone-link]');
        const last = phone && !phone.hidden && phone.getClientRects().length ? phone : status;
        const gap = 16;
        const tolerance = 2;
        const needed = Math.round(last.getBoundingClientRect().bottom + gap - (this.viewportBounds().bottom - overlay));
        if (needed <= tolerance) return;
        const panel = this.flowPanels.find((entry) => Number(entry.dataset.flowStep) === 5) || cta;
        const room = Math.max(0, Math.round(cta.getBoundingClientRect().top - this.stepTopReserve(panel) - this.scrollGap()));
        const delta = Math.min(needed, room);
        if (delta <= tolerance) return;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.scrollWindowTo(window.scrollY + delta, !reduceMotion);
      }

      nextRequiredStep() {
        if (!this.brandId) return 1;
        if (!this.selectedModel) return 2;
        if (!this.selectedRepair) return 3;
        if (!this.isSelectionComplete()) return 4;
        return 5;
      }

      isSelectionComplete() {
        if (!this.brandId || !this.selectedModel || !this.selectedRepair || !this.pricesReady) return false;
        return this.currentOptions.length === 0 || Boolean(this.selectedOption);
      }

      canContinueWithoutOption() {
        return Boolean(this.brandId && this.selectedModel && this.selectedRepair && this.pricesReady && this.currentOptions.length === 0);
      }

      applyModelVisibility() {
        const query = String(this.modelSearch?.value || '').trim().toLocaleLowerCase();
        const brandModels = this.models.filter((model) => model.brandId === this.brandId);
        const brandSeries = [...new Set(brandModels.map((model) => model.series))];
        const previewSeries = new Set(brandSeries.slice(0, 2));
        let visibleCount = 0;
        brandModels.forEach((model) => {
          const matches = !query || model.name.toLocaleLowerCase().includes(query);
          const insideLimit = Boolean(query) || this.modelListExpanded || previewSeries.has(model.series);
          const visible = matches && insideLimit;
          model.button.hidden = !visible;
          if (visible) visibleCount += 1;
        });
        this.models.filter((model) => model.brandId !== this.brandId).forEach((model) => { model.button.hidden = true; });

        this.modelSeries.forEach((series) => {
          if (series.dataset.modelBrand !== this.brandId) {
            series.hidden = true;
            return;
          }
          let sibling = series.nextElementSibling;
          let hasVisibleModel = false;
          while (sibling && !sibling.matches('[data-model-series]')) {
            if (sibling.matches('[data-model-id]') && !sibling.hidden) hasVisibleModel = true;
            sibling = sibling.nextElementSibling;
          }
          series.hidden = !hasVisibleModel;
        });

        if (this.modelToggle) {
          this.modelToggle.hidden = Boolean(query) || brandSeries.length <= 2;
          this.modelToggle.textContent = this.modelListExpanded ? 'Weniger Modelle anzeigen' : 'Weitere Modelle anzeigen';
        }
        if (this.modelStatus) this.modelStatus.hidden = visibleCount > 0;
      }

      syncMobileSummary() {
        if (!this.mobileSummary) return;
        const hasModel = Boolean(this.selectedModel);
        const shouldShow = hasModel && this.activeStep !== 1;
        this.mobileSummary.hidden = !shouldShow;
        this.classList.toggle('has-mobile-summary', shouldShow);
        if (!shouldShow) return;
        this.setText('[data-mobile-summary-model]', this.selectedModel.name);
        const price = this.querySelector('[data-summary-price]')?.textContent?.trim() || '—';
        this.setText('[data-mobile-summary-price]', this.isSelectionComplete() ? price : '—');
        if (this.mobileSummaryAction) {
          // Block B (20.09.2026, F-17): Ist die Auswahl nur anfragbar, heisst der Knopf "Zur Anfrage". Waehrend der Produktabfrage bleibt "Zur Buchung" stehen.
          const inquiryOnly = !this.commercePending && this.querySelector('[data-summary-cta]')?.dataset.mode === 'inquiry';
          this.mobileSummaryAction.textContent = this.isSelectionComplete() ? (inquiryOnly ? 'Zur Anfrage' : 'Zur Buchung') : 'Weiter';
          // Nativer disabled-Zustand, solange die Pflichtauswahl des aktiven
          // Schritts fehlt (Schritt 3: Reparaturart, Schritt 4: Qualität) -
          // vorher war der Klick ein stilles No-op über nextRequiredStep().
          let actionEnabled = true;
          if (this.activeStep === 3) {
            actionEnabled = Boolean(this.selectedRepair);
          } else if (this.activeStep === 4) {
            actionEnabled = this.isSelectionComplete();
          }
          this.mobileSummaryAction.disabled = !actionEnabled;
        }
      }

      // T2 / F-008 (19.09.2026): Die Preisabfrage besteht aus zwei Abrufen - der Preisdatei des Themes und den
      // gepflegten Preisen der Verwaltung, die die Preisdatei ueberschreiben. Vorher blieben bei einem Ausfall der
      // Verwaltung stumm die (moeglicherweise veralteten) Zahlen der Preisdatei stehen, und eine haengende Antwort
      // liess den Schritt leer. Jetzt gilt: EIN Zeitlimit von 12 Sekunden ueber beide Abrufe einschliesslich des
      // Einlesens der Antwort. Schlaegt irgendein Teil fehl (HTTP-Fehler, kein JSON, Netzabbruch, Zeitlimit), zeigt
      // der Konfigurator KEINE Zahl, sondern "Preis auf Anfrage", den Stoerungshinweis und "Erneut versuchen"
      // (setPriceFault). Es wird nie selbsttaetig wiederholt. Der Erfolgsweg ist unveraendert.
      async loadPrices(brandId = this.brandId, { retry = false } = {}) {
        const priceUrl = this.priceUrls[brandId];
        this.pricesReady = false;
        this.setPriceFault(retry ? 'loading' : false);
        if (!priceUrl) {
          this.pricesReady = true;
          this.setPriceFault(false);
          return;
        }
        if (this.priceCache[brandId]) {
          if (brandId !== this.brandId) return;
          this.prices = this.priceCache[brandId];
          this.pricesReady = true;
          this.setPriceFault(false);
          this.renderOptions();
          this.render();
          this.updateProgress();
          if (retry) this.afterPriceRetry(true); // ein aelterer Abruf derselben Marke kann den Zwischenspeicher inzwischen gefuellt haben
          return;
        }

        const requestId = ++this.priceRequestId;
        // Eine verspaetete Antwort (oder ein verspaetetes Zeitlimit) zaehlt nur, solange Marke UND Abruf noch aktuell sind.
        const aktuell = () => brandId === this.brandId && requestId === this.priceRequestId;
        const abruf = this.priceDeadline(12000);
        try {
          const prices = await abruf.json(priceUrl, { credentials: 'same-origin' });
          if (!prices || typeof prices !== 'object' || Array.isArray(prices)) throw new Error('Preisdatei unbrauchbar');
          const managedRows = await this.loadManagedPrices(brandId, abruf);
          this.applyManagedPrices(prices, managedRows, brandId);
          this.priceCache[brandId] = prices;
          if (!aktuell()) return;
          this.prices = prices;
          this.pricesReady = true;
          this.setPriceFault(false);
          this.renderOptions();
          this.render();
          this.updateProgress();
          if (retry) this.afterPriceRetry(true);
        } catch (error) {
          if (!aktuell()) return;
          this.prices = {};
          this.pricesReady = true;
          this.setPriceFault('error');
          this.renderOptions();
          this.render();
          this.updateProgress();
          if (retry) this.afterPriceRetry(false);
        } finally {
          abruf.done();
        }
      }

      // T2: Ein Zeitlimit fuer mehrere Abrufe. Laeuft es ab, werden laufende Abrufe abgebrochen UND das Warten endet
      // sicher (Promise.race) - auch wenn die Antwortkoepfe schon da sind, der Inhalt aber nie vollstaendig ankommt.
      priceDeadline(ms) {
        const controller = new AbortController();
        let timer;
        const limit = new Promise((resolve, reject) => {
          timer = window.setTimeout(() => {
            reject(new Error('Zeitlimit der Preisabfrage'));
            controller.abort();
          }, ms);
        });
        limit.catch(() => {}); // laeuft das Limit ab, waehrend niemand wartet, ist das kein Fehler
        return {
          json: (url, init = {}) => Promise.race([
            fetch(url, { ...init, signal: controller.signal }).then((response) => {
              if (!response.ok) throw new Error('HTTP ' + response.status);
              return response.json();
            }),
            limit
          ]),
          done: () => window.clearTimeout(timer)
        };
      }

      // T2: Fehler werden hier nicht mehr still zu "keine gepflegten Preise" - sonst wirken die Zahlen der Preisdatei
      // wie gueltige Preise. Ohne eingerichtete Verwaltungsquelle bleibt es beim bisherigen Verhalten (nur Preisdatei).
      async loadManagedPrices(brandId, abruf) {
        if (!this.dataset.managedPricesUrl) return [];
        if (this.managedPriceCache[brandId]) return this.managedPriceCache[brandId];
        const url = new URL(this.dataset.managedPricesUrl, window.location.origin);
        url.searchParams.set('brand', brandId);
        url.searchParams.set('displayMetadata', '1');
        const payload = await abruf.json(url, { credentials: 'omit', headers: { Accept: 'application/json' } });
        if (!Array.isArray(payload?.rows)) throw new Error('Preisantwort unbrauchbar');
        this.managedPriceCache[brandId] = payload.rows;
        return payload.rows;
      }

      // T2: Zustand des Stoerungshinweises. false = aus, 'error' = Hinweis mit "Erneut versuchen", 'loading' = laufender
      // Wiederholungsversuch (der Kasten bleibt stehen, der Knopf ist gesperrt - wie im Hausbaustein ivoodoo-async-ui.js).
      setPriceFault(state) {
        this.priceFault = state === 'error';
        const message = !state ? '' : state === 'loading' ? this.data.ui.priceFaultLoading : this.data.ui.priceFault;
        (this.priceFaultNodes || []).forEach((node) => {
          node.dataset.state = state || 'idle'; // 'idle' = Kasten ohne Flaeche (Regel des Hausbausteins), bleibt im Dokument
          const text = node.querySelector('[data-price-fault-text]');
          const actions = node.querySelector('.iv-async-feedback__actions');
          const button = node.querySelector('[data-price-fault-retry]');
          if (text && text.textContent !== message) text.textContent = message;
          if (actions) actions.hidden = !state;
          if (button) button.disabled = state === 'loading';
        });
      }

      retryPrices() {
        if (!this.priceFault || !this.brandId || this.brandId === 'other') return;
        this.priceRetryFocus = true;
        this.loadPrices(this.brandId, { retry: true });
      }

      // T2: Nach einem Wiederholungsversuch. Der Knopf war waehrend des Ladens gesperrt bzw. ist nach dem Erfolg weg -
      // der Tastaturfokus wird deshalb gezielt gesetzt (ohne Scrollen), aber nur, wenn der Kunde ihn nicht inzwischen
      // selbst woanders hingesetzt hat. Fehlt nach dem Erfolg die Qualitaetswahl, geht es zurueck zu diesem Schritt.
      afterPriceRetry(success) {
        const focusFree = !document.activeElement || document.activeElement === document.body
          || this.priceFaultNodes.some((node) => node.contains(document.activeElement));
        const restoreFocus = this.priceRetryFocus && focusFree;
        this.priceRetryFocus = false;
        if (success && this.activeStep === 5 && !this.isSelectionComplete()) this.openStep(this.nextRequiredStep(), { historyMode: 'replace' });
        if (!restoreFocus) return;
        const panel = this.flowPanels.find((entry) => Number(entry.dataset.flowStep) === this.activeStep);
        if (!panel || panel.hidden) return;
        const target = success ? panel.querySelector('h2') : panel.querySelector('[data-price-fault-retry]');
        if (!target) return;
        if (success) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      }

      applyManagedPrices(prices, rows, brandId) {
        if (!this.managedDisplayNames[brandId]) this.managedDisplayNames[brandId] = {};
        if (!this.managedDescriptions[brandId]) this.managedDescriptions[brandId] = {};
        rows.forEach((row) => {
          if (row.brandId !== brandId) return;
          if (!row.model || !row.repair || !row.option) return;
          const labelKey = [row.model, row.repair, row.option].join('\u001f');
          const displayName = String(row.displayName || '').trim();
          if (displayName) this.managedDisplayNames[brandId][labelKey] = displayName;
          if (typeof row.description === 'string') {
            this.managedDescriptions[brandId][labelKey] = row.description;
          }
          const priceCents = Number(row.priceCents);
          if (!Number.isSafeInteger(priceCents) || priceCents <= 0) return;
          if (!prices[row.model] || typeof prices[row.model] !== 'object') prices[row.model] = {};
          if (!prices[row.model][row.repair] || typeof prices[row.model][row.repair] !== 'object') prices[row.model][row.repair] = {};
          prices[row.model][row.repair][row.option] = priceCents / 100;
        });
      }

      displayNameFor(priceKey, fallback = priceKey) {
        if (this.selectedRepair?.id === 'display') {
          const names = { Original: 'Original', Premium: 'Premium', Alternative: 'Qualitätsdisplay' };
          if (Object.prototype.hasOwnProperty.call(names, priceKey)) return names[priceKey];
        }
        const repairPriceKey = this.repairPriceKey(this.selectedRepair?.id);
        const labelKey = [this.selectedModel?.name, repairPriceKey, priceKey].join('\u001f');
        return this.managedDisplayNames?.[this.brandId]?.[labelKey] || fallback;
      }

      descriptionFor(priceKey, fallback) {
        const repairPriceKey = this.repairPriceKey(this.selectedRepair?.id);
        const key = [this.selectedModel?.name, repairPriceKey, priceKey].join('\u001f');
        return this.managedDescriptions?.[this.brandId]?.[key] || this.fixedDescriptionFor(repairPriceKey, priceKey) || fallback;
      }

      // T1-Nachtrag (19.09.2026, Entscheidung Yunus): Apple-Display "Original" traegt einheitlich den Original-Text.
      // In der Verwaltung ist dieser Text bewusst ein fester, nicht pflegbarer Untertitel (liste: repairPriceService
      // lehnt eine Beschreibung fuer "Original" ab) - gepflegt ist er nur bei iPhone 17 und 17 Pro Max, wortgleich mit
      // dem Text hier. Er enthaelt keine Bildwiederholrate und keine Panelangabe. Eine gepflegte Beschreibung hat immer
      // Vorrang; Karte und Zusammenfassung lesen ihn ueber dieselbe Stelle (optionCardTexts).
      fixedDescriptionFor(repairPriceKey, priceKey) {
        if (this.brandId === 'apple' && repairPriceKey === 'Display' && priceKey === 'Original') {
          return this.data.ui.appleOriginalDisplay || '';
        }
        return '';
      }

      // T1 / F-002 (19.09.2026): EINE Textquelle je Option. Karte (renderOptions) und Zusammenfassung (render) lesen
      // beide hier - und damit dieselbe gepflegte Beschreibung der gewaehlten Variante (descriptionFor; Zeile 1 =
      // Kurzangaben, ab Zeile 2 = Text). Die frueheren festen Apple-Kartentexte ("FDX Ultra · 120 Hz ...") sind
      // entfallen: Sie galten fuer alle Modelle und widersprachen bei 60-Hz- und In-Cell-Varianten den gepflegten
      // Angaben. Fehlt eine Beschreibung, steht an beiden Stellen derselbe neutrale Hinweis der Reparaturart
      // (selectedRepair.notice) - hier wird nichts ergaenzt oder abgeleitet, auch keine Bildwiederholrate.
      // Einzige Ausnahme: Apple-Display "Original" ohne gepflegte Beschreibung (fixedDescriptionFor).
      optionCardTexts(option) {
        const detail = String(option?.detail || '');
        if (this.selectedRepair?.id !== 'display') return { sub: '', desc: detail };
        const nl = detail.indexOf('\n');
        if (nl > 0) {
          return {
            sub: detail.slice(0, nl).trim().replace(/\s*\|\s*/g, ' · '),
            desc: detail.slice(nl + 1).replace(/\s+/g, ' ').trim()
          };
        }
        const originalSubtitle = option?.priceKey === 'Original'
          ? (this.brandId === 'apple' ? this.data.ui.appleOriginalDisplaySubtitle : this.data.ui.originalDisplaySubtitle)
          : '';
        return { sub: originalSubtitle || '', desc: detail };
      }

      async loadCommerceProduct() {
        const productUrl = this.commerceUrlForSelection();
        if (!productUrl) {
          ++this.commerceRequestId; // Block H: ein laufender Abruf fuer ein anderes Modell zaehlt nicht mehr
          this.commerceProduct = null;
          this.commercePending = false;
          this.renderOptions();
          this.render();
          return;
        }
        if (this.commerceCache[productUrl]) {
          ++this.commerceRequestId; // Block H: ein laufender Abruf fuer ein anderes Modell zaehlt nicht mehr
          this.commerceProduct = this.commerceCache[productUrl];
          this.commercePending = false;
          this.renderOptions();
          this.render();
          return;
        }

        this.commerceProduct = null;
        this.commercePending = true;
        const requestId = ++this.commerceRequestId;
        // Block H (12.09.2026, Gegenpruefung): Ergebnis nur uebernehmen, solange Abruf UND Auswahl noch aktuell sind.
        const aktuell = () => requestId === this.commerceRequestId && productUrl === this.commerceUrlForSelection();
        try {
          const response = await fetch(productUrl, { credentials: 'same-origin' });
          if (!response.ok) return;
          const product = await response.json();
          if (!product || !Array.isArray(product.variants)) return;
          this.commerceCache[productUrl] = product;
          if (!aktuell()) return;
          this.commerceProduct = product;
          this.commercePending = false;
          this.renderOptions();
          this.render();
        } catch (error) {
          if (aktuell()) this.commerceProduct = null;
        } finally {
          // Block H (12.09.2026): Abruf ohne verwendbares Produkt abgeschlossen - erst jetzt darf der Anfrage-Modus
          // seine Begruendung zeigen (setCtaMode). Bei Erfolg ist oben schon mit commercePending = false gerendert.
          if (aktuell() && this.commercePending) {
            this.commercePending = false;
            this.render();
          }
        }
      }

      parseJson(selector, fallback) {
        try {
          const node = this.querySelector(selector);
          return node ? JSON.parse(node.textContent) : fallback;
        } catch (error) {
          return fallback;
        }
      }

      selectBrand(brandId, { force = false, updateUrl = true, shouldScroll = true, focusSearch = false, preserveInquiry = false, historyMode } = {}) {
        const brandButton = this.brandButtons.find((button) => button.dataset.brandId === brandId);
        if (!brandButton) return;
        if (brandId === 'other') this.invalidateDeferredInteraction();
        if (!force && brandId === this.brandId) {
          if (brandId !== 'other') this.openStep(2, { shouldScroll, focusSearch, historyMode });
          else this.markInquiryBrand(''); // Paket A / F-021: "Weitere Hersteller" wieder markieren
          return;
        }

        this.brandButtons.forEach((button) => {
          const selected = button === brandButton;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });

        this.querySelector('iv-repair-handover')?.reset?.();
        this.brandId = brandId;
        this.brand = brandButton.dataset.brandName;
        this.dynamicOptions = brandId !== 'other';
        const usesInquiry = brandId === 'other';
        this.progress.hidden = usesInquiry;

        this.models.forEach((model) => {
          model.button.hidden = true;
          model.button.classList.remove('is-selected');
          model.button.setAttribute('aria-pressed', 'false');
        });
        this.modelSeries.forEach((series) => { series.hidden = true; });
        this.repairButtons.forEach((button) => {
          button.classList.remove('is-selected');
          button.setAttribute('aria-pressed', 'false');
        });
        this.optionContainer.replaceChildren();
        this.currentOptions = [];
        this.selectedModel = null;
        this.selectedRepair = null;
        this.selectedOption = null;
        this.prices = {};
        this.pricesReady = false;
        this.priceRetryFocus = false;
        this.setPriceFault(false); // T2: der Hinweis gehoert zur Abfrage der vorherigen Marke
        this.commerceProduct = null;
        this.purchaseVariant = null;
        this.modelListExpanded = false;
        if (this.modelSearch) this.modelSearch.value = '';
        this.setText('[data-summary-brand]', this.brand);
        this.setText('[data-summary-model]', '—');
        this.setText('[data-summary-repair]', '—');
        this.setText('[data-summary-option]', '—');
        this.setText('[data-summary-price]', '—');
        this.setCtaMode('incomplete');
        this.syncMobileSummary();

        if (usesInquiry) {
          this.standardFlow.hidden = true;
          this.otherFlow.hidden = false;
          this.brandPanel.hidden = false;
          if (!preserveInquiry) this.otherFlow.querySelector('repair-inquiry')?.resetInquiryState();
          this.markInquiryBrand(''); // Paket A / F-021: Standard-Ueberschrift (openModelInquiry setzt danach die eigene)
          // Paket A / F-044: Die Anfrage ist ein eigener Schritt im Verlauf (kein openStep) - Eintrag hier.
          if (updateUrl) this.updateUrl(brandId, historyMode || (this.historyReady ? 'push' : 'replace'));
          return;
        }

        const modelHeading = this.data.ui.modelHeadings?.[brandId] || this.data.ui.modelHeadings?.apple || '';
        this.modelHeading.textContent = modelHeading;
        this.modelGroup.setAttribute('aria-label', modelHeading);
        // Block B (20.09.2026, F-23): Beispiel im Suchfeld passend zur Marke.
        if (this.modelSearch) this.modelSearch.placeholder = { apple: 'z. B. iPhone 15 Pro', samsung: 'z. B. Galaxy S24', google: 'z. B. Pixel 9' }[brandId] || 'z. B. iPhone 15 Pro';
        this.applyModelVisibility();
        this.openStep(2, { shouldScroll, focusSearch, historyMode });
        this.loadPrices(brandId);
        // Paket A / F-044: openStep(2) hat den Verlaufseintrag angelegt; hier kommt nur die Marke in dessen Adresse.
        if (updateUrl) this.updateUrl(brandId);
      }

      // Block B (20.09.2026, F-04): "Modell nicht dabei?" - wechselt in den vorhandenen Anfrage-Zweig und uebernimmt
      // die gewaehlte Marke sowie den eingetippten Suchtext. Das Formular selbst bleibt unveraendert.
      openModelInquiry() {
        const brandName = this.brandId && this.brandId !== 'other' ? this.brand : '';
        const chosenBrandId = this.brandId && this.brandId !== 'other' ? this.brandId : '';
        const query = String(this.modelSearch?.value || '').trim();
        this.selectBrand('other');
        const inquiry = this.otherFlow?.querySelector('repair-inquiry');
        if (!inquiry) return;
        // Paket A / F-021 (27.09.2026): gewaehlte Marke bleibt markiert, neutrale Ueberschrift.
        this.markInquiryBrand(chosenBrandId);
        const fill = (input, value) => {
          if (!input || !value) return;
          input.value = value;
          input.dispatchEvent(new Event('input', { bubbles: true }));
        };
        const brandInput = inquiry.querySelector('[data-inquiry-brand]');
        const modelInput = inquiry.querySelector('[data-inquiry-model]');
        fill(brandInput, brandName);
        fill(modelInput, query);
        // Das Formular steht unter der Markenauswahl - die Ansicht faehrt dorthin (unter den haengenden Kopfbereich), sonst laege es z. B. nach einem Deep-Link unter dem Bildrand.
        // Paket A / F-021: so weit, dass Ueberschrift und erstes leeres Feld sichtbar sind (revealInquiry).
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const next = [brandInput, modelInput, inquiry.querySelector('[data-inquiry-repair]')].find((input) => input && !input.value.trim());
        this.revealInquiry(inquiry, next, !reduceMotion);
        next?.focus({ preventScroll: true });
      }

      updateUrl(brandId, historyMode = 'replace') {
        const url = new URL(window.location.href);
        url.searchParams.set('brand', brandId);
        url.hash = this.id;
        this.writeHistory(historyMode, url.href); // Paket A / F-044 (Startseite: wie bisher replaceState ohne Eintrag)
      }

      selectModel(model) {
        this.models.forEach((entry) => {
          const selected = entry.id === model.id;
          entry.button.classList.toggle('is-selected', selected);
          entry.button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        if (this.selectedModel?.id !== model.id) this.querySelector('iv-repair-handover')?.reset?.();
        this.selectedModel = model;
        this.selectedRepair = null;
        this.selectedOption = null;
        this.currentOptions = [];
        this.repairButtons.forEach((button) => {
          button.classList.remove('is-selected');
          button.setAttribute('aria-pressed', 'false');
        });
        this.optionContainer.replaceChildren();
        this.commerceProduct = null;
        this.purchaseVariant = null;
        this.setText('[data-summary-model]', model.name);
        this.setText('[data-summary-repair]', '—');
        this.setText('[data-summary-option]', '—');
        this.setText('[data-summary-price]', '—');
        this.setCtaMode('incomplete');
        this.updateProgress(3);
        this.syncMobileSummary();
        this.renderRepairPrices(); // Block H: Ab-Preise des neuen Modells sofort, falls die Preise schon geladen sind
        this.loadCommerceProduct();
        this.openStep(3);
      }

      selectRepair(repairId) {
        this.selectedRepair = this.data.repairs.find((repair) => repair.id === repairId) || null;
        this.selectedOption = null;
        this.repairButtons.forEach((button) => {
          const selected = button.dataset.repairId === repairId;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        this.setText('[data-summary-repair]', this.selectedRepair?.label || '—');
        this.setText('[data-summary-option]', '—');
        this.setText('[data-summary-price]', '—');
        this.setCtaMode('incomplete');
        this.renderOptions();
        this.updateProgress(4);
        this.syncMobileSummary();
        this.openStep(4);
      }

      selectOption(optionId) {
        this.selectedOption = this.currentOptions.find((option) => option.id === optionId) || null;
        this.optionContainer.querySelectorAll('[data-option-id]').forEach((button) => {
          const selected = button.dataset.optionId === optionId;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        this.render();
        this.updateProgress(5);
        this.openStep(5);
      }

      optionHeadingForRepair(repair = this.selectedRepair) {
        if (!repair?.label) return this.data.ui.chooseOption;
        const choiceLabels = {
          display: 'Qualität',
          akku: 'Qualität',
          kamera: 'Ausführung',
          'kamera-glas': 'Option',
          rueckseite: 'Ausführung',
          ladebuchse: 'Option'
        };
        return `${repair.label} – ${choiceLabels[repair.id] || 'Option'} wählen`;
      }

      optionContextForSelection(model = this.selectedModel, repair = this.selectedRepair) {
        return [model?.name, repair?.label].filter(Boolean).join(' · ');
      }

      // Block H (12.09.2026, Befund H12): Auf der Stufe "Reparaturart" traegt jede Karte den guenstigsten
      // hinterlegten Preis des gewaehlten Modells ("ab ...") - aus denselben Preisdaten wie die Optionen in
      // Schritt 4 (this.prices). Ohne Festpreis steht "Preis auf Anfrage"; es wird kein Preis erfunden.
      isRepairExcluded(repairId) {
        const key = `${this.brandId}:${repairId}`;
        return String(this.dataset.excludedRepairs || '').split(',').some((entry) => entry.trim() === key);
      }

      renderRepairPrices() {
        const ready = Boolean(this.dynamicOptions && this.selectedModel && this.pricesReady);
        this.repairButtons.forEach((button) => {
          // Block A (20.09.2026): vom Hersteller nicht angebotene Reparaturarten ausblenden (data-excluded-repairs).
          button.hidden = this.isRepairExcluded(button.dataset.repairId);
          const line = button.querySelector('[data-repair-from-price]');
          if (!line) return;
          if (!ready) {
            line.textContent = '';
            return;
          }
          const group = this.prices?.[this.selectedModel.name]?.[this.repairPriceKey(button.dataset.repairId)];
          const cents = group && typeof group === 'object' && !Array.isArray(group)
            ? Object.values(group)
              .map((raw) => (typeof raw === 'number' ? raw : typeof raw === 'string' && raw.trim() !== '' ? Number(raw.replace(',', '.')) : Number.NaN))
              .filter((value) => Number.isFinite(value) && value > 0)
              .map((value) => Math.round(value * 100))
            : [];
          line.textContent = cents.length
            ? this.data.ui.fromPrice.replace('__PRICE__', this.formatMoney(Math.min(...cents)))
            : this.data.ui.priceOnRequest;
        });
      }

      renderOptions() {
        this.renderRepairPrices();
        const previousOptionId = this.selectedOption?.id || '';
        const options = this.optionsForSelection();
        this.currentOptions = options;
        const heading = this.querySelector('[data-option-heading]');
        const context = this.querySelector('[data-option-context]');
        const contextText = this.optionContextForSelection();
        context.textContent = contextText;
        context.hidden = !contextText;
        this.optionContainer.replaceChildren();
        const isDisplay = this.selectedRepair?.id === 'display';
        this.optionContainer.classList.toggle('repair-configurator__options--display', isDisplay);
        this.selectedOption = options.find((option) => option.id === previousOptionId) || null;
        if (this.optionContinue) this.optionContinue.hidden = true;

        if (!options.length) {
          heading.textContent = this.data.ui.serviceNote;
          const note = document.createElement('p');
          note.className = 'repair-configurator__service-note';
          note.textContent = this.selectedRepair?.notice || 'Bitte wähle zuerst eine Reparatur.';
          this.optionContainer.append(note);
          if (this.optionContinue) this.optionContinue.hidden = !this.canContinueWithoutOption();
          this.setCtaMode('incomplete');
          this.syncMobileSummary();
          return;
        }

        heading.textContent = this.optionHeadingForRepair();
        options.forEach((option) => {
          const selected = option.id === this.selectedOption?.id;
          const button = document.createElement('button');
          button.type = 'button';
          button.className = `repair-configurator__option${selected ? ' is-selected' : ''}`;
          button.dataset.optionId = option.id;
          button.dataset.priceKey = option.priceKey;
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');

          const texts = this.optionCardTexts(option);
          const label = document.createElement('strong');
          label.textContent = option.label;
          button.append(label);
          if (isDisplay) {
            button.classList.add('rc-option--structured');
            const sub = document.createElement('span');
            sub.className = 'rc-option-sub';
            sub.textContent = texts.sub;
            if (!texts.sub) sub.setAttribute('aria-hidden', 'true');
            button.append(sub);
          }
          if (texts.desc) {
            const detail = document.createElement('span');
            if (isDisplay) detail.className = 'rc-option-desc';
            detail.textContent = texts.desc;
            button.append(detail);
          }
          const rawPrice = option.price;
          const numericPrice = typeof rawPrice === 'number'
            ? rawPrice
            : typeof rawPrice === 'string' && rawPrice.trim() !== ''
              ? Number(rawPrice.replace(',', '.'))
              : Number.NaN;
          if (Number.isFinite(numericPrice) && numericPrice > 0) {
            const price = document.createElement('span');
            price.className = 'rc-option-price';
            price.textContent = this.formatMoney(Math.round(numericPrice * 100));
            button.append(price);
          } else {
            // Ohne Festpreis steht der Hinweis direkt auf der Karte statt
            // erst in der Zusammenfassung; kein Preis wird erfunden.
            const price = document.createElement('span');
            price.className = 'rc-option-price rc-option-price--request';
            price.textContent = this.data.ui.priceOnRequest;
            button.append(price);
          }
          button.addEventListener('click', () => this.selectOption(option.id));
          this.optionContainer.append(button);
        });
      }

      optionsForSelection() {
        if (!this.dynamicOptions) {
          return (this.selectedRepair?.options || []).map((option) => ({
            ...option,
            label: this.displayNameFor(option.priceKey, option.label),
            detail: this.descriptionFor(option.priceKey, option.detail)
          }));
        }
        if (!this.selectedModel || !this.selectedRepair) return [];

        const repairPriceKey = this.repairPriceKey(this.selectedRepair.id);
        const priceGroup = this.prices?.[this.selectedModel.name]?.[repairPriceKey];
        if (!priceGroup || typeof priceGroup !== 'object' || Array.isArray(priceGroup)) return [];

        return Object.keys(priceGroup).map((priceKey, index) => ({
          id: `price-option-${index}`,
          priceKey,
          label: this.displayNameFor(priceKey),
          detail: this.descriptionFor(priceKey, this.selectedRepair.notice),
          price: priceGroup[priceKey]
        }));
      }

      render() {
        if (!this.isSelectionComplete()) {
          this.setText('[data-summary-price]', '—');
          this.setCtaMode('incomplete');
          this.syncMobileSummary();
          return;
        }

        const optionLabel = this.selectedOption?.label || this.data.ui.notApplicable;
        // T1 / F-002: dieselben Textteile wie auf der Optionskarte (optionCardTexts) - gleiche Quelle, gleiche Bereinigung.
        const optionTexts = this.selectedOption ? this.optionCardTexts(this.selectedOption) : { sub: '', desc: '' };
        const optionDetail = [optionTexts.sub, optionTexts.desc].filter(Boolean).join('\n') || this.selectedRepair.notice;
        const detailTitle = `${this.selectedRepair.label} – ${this.selectedModel.name}`;

        this.setText('[data-detail-title]', detailTitle);
        this.setText('[data-detail-intro]', this.selectedRepair.intro.replaceAll('__MODEL__', this.selectedModel.name));
        this.setText('[data-detail-symptom]', this.selectedRepair.symptom.replaceAll('__MODEL__', this.selectedModel.name));
        this.setText('[data-detail-work]', this.selectedRepair.work.replaceAll('__MODEL__', this.selectedModel.name));
        this.setText('[data-detail-option]', optionDetail);
        this.setText('[data-detail-notice]', this.selectedRepair.notice);
        // Block B (20.09.2026, UX-04): Hat die Option keinen eigenen Text, stuende derselbe Hinweis zweimal da - dann entfaellt der gelbe Kasten.
        const noticeBox = this.querySelector('[data-detail-notice]')?.closest('.repair-configurator__notice');
        if (noticeBox) noticeBox.hidden = optionDetail === this.selectedRepair.notice;
        this.setText('[data-summary-model]', this.selectedModel.name);
        this.setText('[data-summary-repair]', this.selectedRepair.label);
        this.setText('[data-summary-option]', optionLabel);

        this.updatePrice(optionLabel);
        this.updateProgress();
      }

      updatePrice(optionLabel) {
        const priceKey = this.selectedOption?.priceKey || this.defaultPriceKey(this.selectedRepair.id);
        const repairPriceKey = this.repairPriceKey(this.selectedRepair.id);
        const rawPrice = this.prices?.[this.selectedModel.name]?.[repairPriceKey]?.[priceKey];
        const numericPrice = typeof rawPrice === 'number'
          ? rawPrice
          : typeof rawPrice === 'string' && rawPrice.trim() !== ''
            ? Number(rawPrice.replace(',', '.'))
            : Number.NaN;
        const price = this.querySelector('[data-summary-price]');
        const priceNote = this.querySelector('[data-summary-price-note]');
        const hasPrice = Number.isFinite(numericPrice) && numericPrice > 0;
        const localPriceCents = hasPrice ? Math.round(numericPrice * 100) : null;
        const commerceVariant = this.resolveCommerceVariant({
          localPriceCents,
          priceKey,
          repairPriceKey
        });
        const fixedPriceCents = commerceVariant ? Number(commerceVariant.price) : null;
        const displayPriceCents = fixedPriceCents || localPriceCents;
        const formattedPrice = displayPriceCents ? this.formatMoney(displayPriceCents) : '';

        price.textContent = displayPriceCents
          ? this.selectedRepair.id === 'datenrettung'
            ? this.data.ui.fromPrice.replace('__PRICE__', formattedPrice)
            : formattedPrice
          : this.selectedRepair.id === 'datenrettung'
            ? this.data.ui.fromPriceOnRequest
            : this.data.ui.priceOnRequest;
        priceNote.textContent = this.data.ui.priceNote;

        if (commerceVariant) {
          this.setCtaMode('cart', optionLabel, commerceVariant);
        } else {
          this.setCtaMode('inquiry', optionLabel);
        }
        this.syncMobileSummary();
      }

      resolveCommerceVariant({ localPriceCents, priceKey, repairPriceKey }) {
        if (!this.commerceProduct) return null;

        if (!Number.isInteger(localPriceCents) || localPriceCents <= 0) return null;
        const expectedSku = this.buildCommerceSku(this.brandId, this.selectedModel.name, repairPriceKey, priceKey);
        const variant = this.commerceProduct.variants.find((entry) => entry.sku === expectedSku);
        const shopifyPriceCents = Number(variant?.price);
        if (variant?.available !== true || !Number.isInteger(shopifyPriceCents) || shopifyPriceCents <= 0) return null;
        return shopifyPriceCents === localPriceCents ? variant : null;
      }

      commerceUrlForSelection() {
        const productHandle = `ivoodoo-reparatur-${this.commerceHandlePart(this.selectedModel?.name)}`;
        return this.selectedModel ? `${window.theme?.routes?.root_url || '/'}products/${productHandle}.js` : '';
      }

      commerceHandlePart(value) {
        return this.commerceSkuPart(value).toLowerCase();
      }

      buildCommerceSku(brandId, modelName, repairName, optionName) {
        return ['IVR', brandId, modelName, repairName, optionName]
          .map((part) => this.commerceSkuPart(part))
          .filter(Boolean)
          .join('-');
      }

      commerceSkuPart(value) {
        return String(value || '')
          .replaceAll('ß', 'ss')
          .replaceAll('+', ' plus ')
          .normalize('NFKD')
          .replace(/[\u0300-\u036f]/g, '')
          .toUpperCase()
          .replace(/[^A-Z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
      }

      formatMoney(priceCents) {
        return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
          style: 'currency',
          currency: 'EUR'
        }).format(priceCents / 100);
      }

      setCtaMode(mode, optionLabel, variant = null) {
        const cta = this.querySelector('[data-summary-cta]');
        const ctaLabel = this.querySelector('[data-summary-cta-label]');
        const requestIcon = this.querySelector('[data-summary-request-icon]');
        const status = this.querySelector('[data-summary-cta-status]');
        const phoneLink = this.querySelector('[data-summary-phone-link]');
        const productForm = this.querySelector('.repair-configurator__product-form');
        const paymentButton = this.querySelector('[data-repair-payment-button]');
        const purchaseActions = this.querySelector('[data-purchase-actions]');
        if (!cta || !ctaLabel) return;

        cta.classList.remove('is-loading');
        cta.removeAttribute('aria-busy');
        // Block H (12.09.2026, Gegenpruefung): Die Statuszeile ist eine Live-Region. Bleibt es beim Anfrage-Modus mit
        // derselben Begruendung, wird sie nicht geleert und neu gesetzt - sonst liest der Screenreader sie bei jedem
        // Optionswechsel erneut vor.
        // T2 / F-008: Bei einer Stoerung der Preisabfrage waere "nicht direkt online buchbar" eine falsche Aussage ueber
        // das Geraet - dann nennt die Zeile die Stoerung (der Weg zum Wiederholen steht im Hinweis oben in der Karte).
        const inquiryText = this.priceFault
          ? this.data.ui.priceFaultInquiry
          : 'Diese Auswahl ist nicht direkt online buchbar. Frag sie unverbindlich an – wir melden uns bei dir.';
        const bleibtAnfrage = mode !== 'incomplete' && mode !== 'unavailable' && !(mode === 'cart' && variant)
          && !this.commercePending && !status.hidden && status.textContent === inquiryText && !status.classList.contains('is-error');
        if (!bleibtAnfrage) {
          status.hidden = true;
          status.textContent = '';
        }
        status.classList.remove('is-error'); // Block B: jeder Auswahlwechsel stellt den Fehlerzustand zurueck.
        this.paymentMarkup = ''; // Express im Konfigurator: erst wieder nach loadPaymentButton() fuer die neue Auswahl
        if (paymentButton) paymentButton.hidden = true;
        if (purchaseActions) purchaseActions.classList.remove('has-payment-button');
        // Block H (12.09.2026, Befunde H11/H16): Buchungshinweis nur im Warenkorb-Modus, Kontaktformular nur im
        // Anfrage-Modus - jeder Zweig unten blendet ein, was er braucht.
        const orderNote = this.querySelector('[data-order-note]');
        const contactLink = this.querySelector('[data-summary-contact-link]');
        if (orderNote) orderNote.hidden = true;
        if (contactLink) contactLink.hidden = true;

        const handover = this.querySelector('iv-repair-handover');
        if (handover) handover.hidden = mode !== 'cart' || !variant;

        if (mode === 'incomplete') {
          this.purchaseVariant = null;
          cta.dataset.mode = 'incomplete';
          cta.removeAttribute('href'); // Block E2: gesperrter Zustand ohne leeres Linkziel
          cta.removeAttribute('target');
          cta.removeAttribute('rel');
          cta.setAttribute('aria-disabled', 'true');
          ctaLabel.textContent = 'Auswahl vervollständigen';
          requestIcon.hidden = true;
          if (productForm) productForm.hidden = true;
          if (phoneLink) phoneLink.hidden = true;
          return;
        }

        if (mode === 'cart' && variant) {
          this.purchaseVariant = variant;
          this.syncProductForm();
          cta.dataset.mode = 'cart';
          cta.href = window.theme?.routes?.cart_url || '/cart';
          cta.removeAttribute('target');
          cta.removeAttribute('rel');
          cta.removeAttribute('aria-disabled');
          ctaLabel.textContent = this.data.ui.orderCta;
          requestIcon.hidden = true;
          if (productForm) productForm.hidden = false;
          if (phoneLink) phoneLink.hidden = true;
          if (orderNote) orderNote.hidden = false;
          this.loadPaymentButton();
          return;
        }

        if (mode === 'unavailable') {
          this.purchaseVariant = null;
          cta.dataset.mode = 'unavailable';
          cta.removeAttribute('href'); // Block E2: gesperrter Zustand ohne leeres Linkziel
          cta.removeAttribute('target');
          cta.removeAttribute('rel');
          cta.setAttribute('aria-disabled', 'true');
          ctaLabel.textContent = this.data.ui.unavailableCta;
          requestIcon.hidden = true;
          if (productForm) productForm.hidden = true;
          status.textContent = this.data.ui.mappingError;
          status.hidden = false;
          status.classList.add('is-error');
          if (phoneLink) phoneLink.hidden = false; // Block B: gesperrter Zustand behaelt den Kontaktweg.
          return;
        }

        this.purchaseVariant = null;
        cta.dataset.mode = 'inquiry';
        cta.href = this.buildWhatsappUrl(optionLabel);
        cta.target = '_blank';
        cta.rel = 'noopener';
        cta.removeAttribute('aria-disabled');
        ctaLabel.textContent = this.data.ui.requestCta;
        requestIcon.hidden = false;
        if (productForm) productForm.hidden = true;
        if (phoneLink) phoneLink.hidden = false;
        if (contactLink) contactLink.hidden = false;
        // Block H (12.09.2026, Befund H16): Grund nennen, warum hier nur angefragt werden kann - erst wenn der
        // Produktabruf abgeschlossen ist (sonst blitzt der Satz waehrend des Ladens auf).
        if (!this.commercePending) {
          if (status.textContent !== inquiryText) status.textContent = inquiryText;
          status.hidden = false;
        }
      }

      revealHandover() {
        const handover = this.querySelector('iv-repair-handover');
        if (!handover || handover.hidden || !handover.getClientRects().length) return;
        const top = this.stepTopReserve(handover) + this.scrollGap();
        const bottom = this.viewportBounds().bottom - this.bottomOverlayHeight() - this.scrollGap();
        const rect = handover.getBoundingClientRect();
        if (bottom <= top) return;
        const delta = rect.top < top
          ? rect.top - top
          : Math.min(Math.max(0, rect.bottom - bottom), Math.max(0, rect.top - top));
        if (Math.abs(delta) > 2) this.scrollWindowTo(Math.max(0, window.scrollY + delta), false);
      }

      syncProductForm() {
        if (!this.purchaseVariant || !this.selectedModel || !this.selectedRepair) return;
        this.setFormValue('[data-repair-variant-id]', this.purchaseVariant.id);
        this.setFormValue('[data-repair-product-id]', this.commerceProduct?.id);
        this.setFormValue('[data-repair-property="manufacturer"]', this.brand);
        this.setFormValue('[data-repair-property="device"]', this.deviceLabel());
        this.setFormValue('[data-repair-property="model"]', this.selectedModel.name);
        this.setFormValue('[data-repair-property="repair"]', this.repairLineLabel());
        this.setFormValue('[data-repair-property="option"]', this.selectedOption?.label || this.data.ui.standardOption);
      }

      async loadPaymentButton() {
        const productUrl = this.commerceUrlForSelection();
        const paymentButton = this.querySelector('[data-repair-payment-button]');
        if (!productUrl || !paymentButton || !this.purchaseVariant) return;

        const requestId = ++this.paymentButtonRequestId;
        // Express im Konfigurator (27.09.2026, Freigabe Yunus): Quelle ist die schlanke Ansicht ?view=iv-express
        // (templates/product.iv-express.liquid, mit Zahlungsregel). Vorher wurde die Reparatur-Produktseite gelesen; dort lag
        // das Markup seit Block F (08.09.2026) in einem <template> und wurde nicht gefunden - seitdem gab es hier kein Express.
        const sectionUrl = productUrl.replace(/\.js(?:\?.*)?$/, '') + '?view=iv-express';
        try {
          let paymentMarkup = this.paymentButtonCache[sectionUrl];
          if (paymentMarkup === undefined) {
            const response = await fetch(sectionUrl, { credentials: 'same-origin' });
            if (!response.ok) return;
            const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
            paymentMarkup = documentFragment.querySelector('[data-shopify="payment-button"]')?.outerHTML || '';
            this.paymentButtonCache[sectionUrl] = paymentMarkup;
          }
          if (requestId !== this.paymentButtonRequestId || productUrl !== this.commerceUrlForSelection()) return;
          this.paymentMarkup = paymentMarkup;
          this.paymentMarkupVersion = (this.paymentMarkupVersion || 0) + 1;
          this.syncPaymentButton();
        } catch (error) {
          if (requestId === this.paymentButtonRequestId) paymentButton.hidden = true;
        }
      }

      // Express im Konfigurator (27.09.2026): Die Knoepfe stehen im Produktformular des Konfigurators (Variante, Reparatur-
      // angaben, per form-Attribut auch die Uebergabe). Express umgeht aber die Pruefung von "In den Warenkorb" - ohne
      // Uebergabeart ginge die Buchung ohne diese Pflichtangabe raus (Regel Yunus 20.09.2026). Deshalb erst sichtbar, wenn
      // eine Uebergabeart gewaehlt ist; jede neue Auswahl (setCtaMode) blendet sie aus, bis neu geladen ist.
      syncPaymentButton() {
        const paymentButton = this.querySelector('[data-repair-payment-button]');
        const purchaseActions = this.querySelector('[data-purchase-actions]');
        if (!paymentButton) return;
        const cartMode = this.querySelector('[data-summary-cta]')?.dataset.mode === 'cart' && Boolean(this.purchaseVariant);
        const chosen = Boolean(this.querySelector('iv-repair-handover')?.value);
        const show = Boolean(this.paymentMarkup) && cartMode && chosen;
        paymentButton.hidden = !show;
        purchaseActions?.classList.toggle('has-payment-button', show);
        if (!show) return;
        this.syncProductForm();
        if (paymentButton.dataset.markupVersion === String(this.paymentMarkupVersion)) return;
        // Review 27.09.: Einsetzen (und Shopify.PaymentButton.init) erst, wenn der Bereich wirklich sichtbar ist - z. B. ruft
        // selectOption() render() vor openStep(5) auf; in einem verborgenen Schritt bemessen sich die Wallet-Knoepfe falsch.
        // openStep(5) ruft syncPaymentButton() erneut auf. init nur direkt nach dem Einsetzen.
        const version = this.paymentMarkupVersion;
        window.requestAnimationFrame(() => window.requestAnimationFrame(() => {
          if (version !== this.paymentMarkupVersion || paymentButton.hidden || !paymentButton.getClientRects().length) return;
          if (paymentButton.dataset.markupVersion === String(version)) return;
          paymentButton.innerHTML = this.paymentMarkup;
          paymentButton.dataset.markupVersion = String(version);
          window.Shopify?.PaymentButton?.init?.();
        }));
      }

      async handleSummaryCta(event) {
        const cta = event.currentTarget;
        if (cta.dataset.mode === 'unavailable' || cta.dataset.mode === 'incomplete' || cta.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
          return;
        }
        if (cta.dataset.mode !== 'cart') return;
        event.preventDefault();
        if (!this.purchaseVariant || cta.classList.contains('is-loading')) return;

        if (!this.querySelector('iv-repair-handover')?.validate?.()) return;

        const status = this.querySelector('[data-summary-cta-status]');
        const ctaLabel = this.querySelector('[data-summary-cta-label]');
        const form = this.querySelector('[data-repair-product-form]');
        const submit = this.querySelector('[data-repair-product-submit]');
        if (!form || !submit) return;

        this.syncProductForm();

        cta.classList.add('is-loading');
        cta.setAttribute('aria-busy', 'true');
        ctaLabel.textContent = this.data.ui.addingToCart;
        status.hidden = true;
        status.textContent = '';

        let completed = false;
        const reset = (errorMessage = '') => {
          if (completed) return;
          completed = true;
          window.clearTimeout(timeout);
          document.removeEventListener('cart:item-added', handleSuccess);
          document.removeEventListener('product:variant-error', handleError);
          cta.classList.remove('is-loading');
          cta.removeAttribute('aria-busy');
          ctaLabel.textContent = this.data.ui.orderCta;
          status.textContent = errorMessage;
          status.hidden = !errorMessage;
          // Block B: Der Fehlerfall ist als Hinweisbox erkennbar und bietet den Telefonweg an,
          // der im Anfrage-Modus ohnehin schon unter der Buchung steht.
          status.classList.toggle('is-error', Boolean(errorMessage));
          const phoneLinkReset = this.querySelector('[data-summary-phone-link]');
          if (phoneLinkReset) phoneLinkReset.hidden = !errorMessage;
          if (errorMessage) this.revealCartError();
        };
        const handleSuccess = () => reset();
        const handleError = () => reset(this.data.ui.cartError);
        const timeout = window.setTimeout(handleError, 15000);

        document.addEventListener('cart:item-added', handleSuccess, { once: true });
        document.addEventListener('product:variant-error', handleError, { once: true });
        form.requestSubmit(submit);
      }

      setFormValue(selector, value) {
        const input = this.querySelector(selector);
        if (input) input.value = value == null ? '' : String(value);
      }

      deviceLabel() {
        const brand = String(this.brand || '').trim();
        const model = String(this.selectedModel?.name || '').trim();
        if (!brand || model.toLocaleLowerCase().startsWith(brand.toLocaleLowerCase())) return model;
        return `${brand} ${model}`;
      }

      repairLineLabel() {
        const label = String(this.selectedRepair?.label || '').trim();
        return /reparatur$/i.test(label) ? label : `${label} Reparatur`;
      }

      defaultPriceKey(repairId) {
        const keys = {
          'kamera-glas': 'Standard',
          hoermuschel: 'Standard',
          mikrofon: 'Standard',
          wasserschaden: 'Diagnose',
          datenrettung: 'Ab-Preis',
          diagnose: 'Standard'
        };
        return keys[repairId] || 'Standard';
      }

      repairPriceKey(repairId) {
        const keys = {
          display: 'Display',
          akku: 'Akku',
          ladebuchse: 'Ladebuchse',
          kamera: 'Kamera',
          'kamera-glas': 'Kamera-Glas',
          rueckseite: 'Rückseite',
          hoermuschel: 'Hörmuschel',
          mikrofon: 'Mikrofon',
          wasserschaden: 'Wasserschaden',
          datenrettung: 'Datenrettung',
          diagnose: 'Diagnose'
        };
        return keys[repairId] || repairId;
      }

      buildWhatsappUrl(optionLabel) {
        const lines = [
          this.data.ui.messageIntro,
          '',
          `${this.data.ui.messageBrand}: ${this.brand}`,
          `${this.data.ui.messageModel}: ${this.selectedModel.name}`,
          `${this.data.ui.messageRepair}: ${this.selectedRepair.label}`,
          `${this.data.ui.messageOption}: ${optionLabel}`
        ];
        const separator = this.dataset.whatsappUrl.includes('?') ? '&' : '?';
        return `${this.dataset.whatsappUrl}${separator}text=${encodeURIComponent(lines.join('\n'))}`;
      }

      setText(selector, value) {
        const element = this.querySelector(selector);
        if (element) element.textContent = value;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sell-category-selector"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sell-category-selector')) {
    // Luft fuer die Scroll-Ausrichtung beim Oeffnen eines Ankaufbereichs (siehe alignViewport):
    // top = Sticky-Header -> Kopfblock (Eyebrow), heading = Mindestluft Sticky-Header -> Hauptueberschrift,
    // bottom = Luft unter der ersten Auswahlreihe von Schritt 1, tolerance = kein Scroll bei <= 2px Abweichung.
    const SCROLL_GAPS = { top: 16, heading: 8, bottom: 24, tolerance: 2 };
    customElements.define('sell-category-selector', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.interactionGeneration = 0;
        this.selectedCategory = null;
        this.categoryContents = [...document.querySelectorAll('[data-category-content]')];
        this.mainHeader = this.querySelector('[data-main-category-header]');
        this.mainCategories = this.querySelector('[data-main-categories]');
        this.selectedSummary = this.querySelector('[data-selected-category]');
        this.selectedSummaryLabel = this.querySelector('[data-selected-category-label]');
        this.mainCards = [...this.querySelectorAll('[data-category]')];
        this.subcategoryCards = [...this.querySelectorAll('[data-subcategory]')];
        this.subcategories = this.querySelector('[data-subcategories]');
        this.status = this.querySelector('[data-category-status]');
        this.handleClick = event => this.onClick(event);
        this.keptContents = this.keptContents || new Set(); // Review 27.09.: per Zurueck/Vor ausgeblendete Bereiche (siehe leaveContent)
        this.handlePageShow = event => { if (event.persisted) this.restoreSelectionFromUrl(); };
        // Paket A / F-044 (27.09.2026): Browser-Zurueck/-Vor zwischen den Kategorie-Eintraegen (updateUrl legt sie an).
        // Nur wenn sich die Kategorie der Adresse von der offenen unterscheidet - sonst (z. B. Sprungmarke) nichts tun.
        this.handlePopState = () => {
          const raw = new URL(window.location.href).searchParams.get('category') || '';
          const category = raw.replace(/[^a-z0-9_-]/gi, '');
          if ((this.selectedCategory || '') === category) return;
          // Review 27.09.: Zurueck/Vor blendet Bereiche nur um - eingegebene Ankaufsdaten bleiben erhalten (kein
          // resetCategoryState), damit "Vor" die Kategorie so zurueckbringt, wie der Kunde sie verlassen hat.
          this.keepCategoryState = true;
          try {
            this.restoreSelectionFromUrl();
          } finally {
            this.keepCategoryState = false;
          }
        };
        this.addEventListener('click', this.handleClick);
        window.addEventListener('pageshow', this.handlePageShow);
        window.addEventListener('popstate', this.handlePopState);
        this.restoreSelectionFromUrl();
        // Zustand ist jetzt per hidden-Attributen gesetzt - die Vorab-Markierung des Inline-Skripts
        // (Direktaufruf, siehe Markup) wird nicht mehr gebraucht und darf spaeter nichts ueberdecken.
        document.documentElement.removeAttribute('data-iv-sell-category');
        this.correctInitialScroll();
      }

      disconnectedCallback() {
        this.invalidateDeferredInteraction();
        this.removeEventListener('click', this.handleClick);
        window.removeEventListener('pageshow', this.handlePageShow);
        window.removeEventListener('popstate', this.handlePopState);
      }

      onClick(event) {
        this.invalidateDeferredInteraction();
        const change = event.target.closest('[data-change-category]');
        if (change && this.contains(change)) {
          event.preventDefault();
          this.resetSelection();
          this.updateUrl('');
          this.scrollIntoView({ behavior: 'smooth', block: 'start' });
          const focusRequest = this.watchDeferredInteraction();
          setTimeout(() => {
            focusRequest.controller.abort();
            if (focusRequest.generation !== this.interactionGeneration || this.selectedCategory || !this.isConnected) return;
            if (document.activeElement !== focusRequest.focus && document.activeElement !== document.body) return;
            this.querySelector('[data-category="smartphones"]')?.focus({ preventScroll: true });
          }, 180);
          return;
        }

        const back = event.target.closest('[data-subcategory-back]');
        if (back && this.contains(back)) {
          event.preventDefault();
          this.resetSelection();
          this.updateUrl('');
          this.setStatus('');
          this.querySelector('[data-category="more"]')?.focus();
          return;
        }

        const subcategory = event.target.closest('[data-subcategory]');
        if (subcategory && this.contains(subcategory)) {
          // Unterkategorien mit eigenem Bereich auf dieser Seite (Weitere
          // Elektronik: Konsolen/Kameras/Wearables/Sonstiges) öffnen wie
          // Hauptkategorien; ohne passenden Bereich bleibt die Karte ein
          // normaler Link (Fallback).
          const target = subcategory.dataset.categoryTarget || '';
          const hasContent = target && this.categoryContents.some(content => content.dataset.categoryContent === target);
          if (hasContent) {
            if (this.neuerTabGewuenscht(event, subcategory)) return;
            event.preventDefault();
            this.selectedCategory = target;
            this.selectCards(this.subcategoryCards, subcategory);
            this.showCategory(target);
            this.updateUrl(target);
            const label = subcategory.dataset.categoryLabel || subcategory.querySelector('.ivoodoo-selection-card__label')?.textContent?.trim() || 'Ankauf';
            this.collapseSelection(label);
            this.setStatus(`${label} geöffnet.`);
            this.scrollToCategory(target);
            return;
          }
          this.selectCards(this.subcategoryCards, subcategory);
          this.setStatus(`${subcategory.querySelector('.ivoodoo-selection-card__label')?.textContent?.trim() || 'Unterkategorie'} wird geöffnet.`);
          return;
        }

        const card = event.target.closest('[data-category]');
        if (!card || !this.contains(card)) return;
        const category = card.dataset.category;

        if (['smartphones', 'laptops', 'tablets'].includes(category)) {
          // Block H (12.09.2026): Strg-/Cmd-/Umschalt-Klick auf eine Link-Kachel oeffnet wie gewohnt einen neuen
          // Tab bzw. ein neues Fenster; nur der normale Klick bleibt die Auswahl auf dieser Seite.
          if (this.neuerTabGewuenscht(event, card)) return;
          event.preventDefault();
          this.selectedCategory = category;
          this.selectCards(this.mainCards, card);
          this.hideSubcategories();
          this.showCategory(category);
          this.updateUrl(category);
          const labels = { smartphones: 'Smartphone-Ankauf', laptops: 'MacBook- & Laptop-Ankauf', tablets: 'Tablet-Ankauf' };
          const label = card.dataset.categoryLabel || labels[category];
          this.collapseSelection(label);
          this.setStatus(`${label} geöffnet.`);
          this.scrollToCategory(category);
          return;
        }

        if (category === 'more') {
          event.preventDefault();
          this.selectedCategory = category;
          this.selectCards(this.mainCards, card);
          this.hideCategories();
          this.showSubcategories();
          this.updateUrl('more'); // Review 27.09. (F-044): eigener Verlaufseintrag fuer die Unterkategorien-Liste
          this.setStatus('Wähle jetzt eine Unterkategorie aus.');
          return;
        }

        this.selectedCategory = category;
        this.selectCards(this.mainCards, card);
        this.hideCategories();
        this.hideSubcategories();
      }

      neuerTabGewuenscht(event, card) {
        return Boolean(card && card.matches('a[href]') && (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0));
      }

      selectCards(cards, selectedCard) {
        cards.forEach(card => {
          const selected = card === selectedCard;
          card.classList.toggle('is-selected', selected);
          if (card.matches('button')) card.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
      }

      // Review 27.09.: Verlassen eines Bereichs. Per Zurueck/Vor nur ausgeblendete Bereiche behalten ihre Eingaben
      // (keptContents); bei der naechsten aktiven Kategoriewahl werden sie wie jeder verlassene Bereich zurueckgesetzt.
      leaveContent(content) {
        if (typeof content.resetCategoryState !== 'function') return;
        if (this.keepCategoryState) {
          if (!content.hidden) this.keptContents.add(content);
          return;
        }
        if (!content.hidden || this.keptContents.has(content)) content.resetCategoryState();
        this.keptContents.delete(content);
      }

      showCategory(category) {
        this.categoryContents.forEach(content => {
          const selected = content.dataset.categoryContent === category;
          if (selected) this.keptContents.delete(content);
          else this.leaveContent(content);
          content.hidden = !selected;
          content.setAttribute('aria-hidden', selected ? 'false' : 'true');
        });
      }

      collapseSelection(label) {
        this.mainHeader.hidden = true;
        this.mainCategories.hidden = true;
        this.subcategories.hidden = true;
        this.selectedSummaryLabel.textContent = label;
        this.selectedSummary.hidden = false;
        this.classList.add('is-collapsed');
      }

      expandSelection() {
        this.mainHeader.hidden = false;
        this.mainCategories.hidden = false;
        this.selectedSummary.hidden = true;
        this.classList.remove('is-collapsed');
      }

      // ------------------------------------------------------------------------------
      // Kategorieoeffnung: erster Formularblock statt Einleitung. Die bestehende
      // sofortige Scrollfunktion vermeidet eine zweite Animation und gilt auch bei
      // reduzierter Bewegung. Die separate Erstaufruf-Geometrie bleibt darunter erhalten.
      // ------------------------------------------------------------------------------
      scrollToCategory(category) {
        const target = this.categoryContents.find(content => content.dataset.categoryContent === category);
        if (!target) return;
        const request = this.watchDeferredInteraction();
        window.requestAnimationFrame(() => {
          request.controller.abort();
          if (request.generation !== this.interactionGeneration || this.selectedCategory !== category
            || !this.isConnected || target.hidden || !target.getClientRects().length) return;
          this.alignCategoryViewport(target);
        });
      }

      invalidateDeferredInteraction() {
        this.interactionGeneration += 1;
        this.deferredInteractionController?.abort();
      }

      watchDeferredInteraction() {
        const controller = new AbortController();
        this.deferredInteractionController = controller;
        const invalidate = () => this.invalidateDeferredInteraction();
        ['pointerdown', 'touchstart', 'wheel', 'keydown', 'click', 'input'].forEach(type => {
          window.addEventListener(type, invalidate, { capture: true, passive: true, signal: controller.signal });
        });
        return { generation: this.interactionGeneration, controller, focus: document.activeElement };
      }

      categoryHeaderBottom() {
        const header = document.querySelector('theme-header');
        const wrapper = header?.closest('.header-section');
        if (!header || !wrapper) return this.stickyHeaderHeight();
        const style = window.getComputedStyle(wrapper);
        if (style.position !== 'sticky' && style.position !== 'fixed') return 0;
        const wasCompact = header.classList.contains('iv-header-compact');
        const compact = header.desktopHeader?.matches && header.classList.contains('style5')
          && header.classList.contains('header-sticky--active')
          && !header.querySelector('.searchform')?.contains(document.activeElement);
        // Gleiche Messung wie im akzeptierten Reparatur-Konfigurator, ohne ihn zu aendern.
        try {
          if (compact) header.classList.add('iv-header-compact');
          return Math.max(0, parseFloat(style.top) || 0) + header.getBoundingClientRect().height;
        } finally {
          header.classList.toggle('iv-header-compact', wasCompact);
        }
      }

      alignCategoryViewport(target) {
        const panel = target.querySelector('.smartphone-buyback__steps > .ivoodoo-selection-panel');
        if (!panel?.getClientRects().length) return;
        const mobileSummary = target.querySelector('[data-mobile-summary]');
        const mobileStyle = mobileSummary && window.getComputedStyle(mobileSummary);
        const summaryReserve = mobileSummary?.getClientRects().length && mobileStyle.position === 'sticky'
          ? mobileSummary.getBoundingClientRect().height + (parseFloat(mobileStyle.marginBottom) || 0)
          : 0;
        const top = panel.getBoundingClientRect().top + window.scrollY - this.categoryHeaderBottom() - 8 - summaryReserve;
        const maximum = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        const next = Math.max(0, Math.min(maximum, Math.round(top)));
        if (Math.abs(next - window.scrollY) > SCROLL_GAPS.tolerance) this.scrollWindowTo(next);
      }

      // Hoehe des oben haengenden Kopfbereichs (nur wenn er wirklich sticky/fixed ist,
      // sonst verdeckt er nach dem Scrollen nichts). Fallback: Theme-Variable --header-height.
      stickyHeaderHeight() {
        const header = document.querySelector('.header-section') || document.querySelector('theme-header');
        if (header) {
          const position = window.getComputedStyle(header).position;
          if (position !== 'sticky' && position !== 'fixed') return 0;
          return Math.max(0, header.getBoundingClientRect().height);
        }
        const value = parseFloat(window.getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
        return Number.isFinite(value) ? Math.max(0, value) : 0;
      }

      // Unterkante dessen, was nach dem Oeffnen mindestens sichtbar sein soll: Kopf von
      // Schritt 1 plus erste Auswahlreihe (Hersteller-Karten bzw. erstes Eingabefeld).
      stepFocusBottom(target) {
        const panel = target.querySelector('.ivoodoo-selection-panel') || target;
        const firstOption = panel.querySelector('[data-brands] > *, .device-buyback__field input, .device-buyback__field select');
        const heading = panel.querySelector('.ivoodoo-selection-heading');
        const candidate = firstOption || heading;
        const rect = candidate ? candidate.getBoundingClientRect() : null;
        if (rect && rect.height > 0) return rect.bottom;
        const panelRect = panel.getBoundingClientRect();
        return panelRect.top + Math.min(panelRect.height, window.innerHeight * 0.45);
      }

      scrollWindowTo(top) {
        // Sofortiger Sprung ohne Animation - unabhaengig von html { scroll-behavior: smooth }.
        const root = document.documentElement;
        const previous = root.style.scrollBehavior;
        root.style.scrollBehavior = 'auto';
        window.scrollTo(window.scrollX, top);
        root.style.scrollBehavior = previous;
      }

      // Ziel-Scrollposition (Dokumentkoordinaten) fuer einen sichtbaren Ankaufbereich, null wenn
      // der Bereich keinen Kopfblock hat oder gerade nicht dargestellt wird.
      targetScrollTop(target) {
        if (!target || target.hidden || !target.getClientRects().length) return null;
        const headerBlock = target.querySelector('.smartphone-buyback__header');
        const heading = headerBlock ? headerBlock.querySelector('h1, h2') : null;
        if (!headerBlock || !heading) return null;
        const scrollY = window.scrollY;
        const stickyTop = this.stickyHeaderHeight();
        const blockTop = headerBlock.getBoundingClientRect().top + scrollY;
        const headingTop = heading.getBoundingClientRect().top + scrollY;
        const focusBottom = this.stepFocusBottom(target) + scrollY;
        // Obergrenzen: bis hierhin darf gescrollt werden, ohne dass die Hauptueberschrift
        // (hart) bzw. der komplette Kopfblock (weich) unter den Sticky-Header rutscht.
        const upperHard = Math.max(0, Math.floor(headingTop - stickyTop - SCROLL_GAPS.heading));
        const upperSoft = Math.max(0, Math.min(upperHard, Math.floor(blockTop - stickyTop - SCROLL_GAPS.top)));
        // Untergrenze: ab hier liegen Schritt 1 und die erste Auswahlreihe im Viewport.
        const lower = Math.max(0, Math.ceil(focusBottom + SCROLL_GAPS.bottom - window.innerHeight));
        // Ziel: Kopfblock direkt unter dem Header. Passt Schritt 1 dann nicht ins Bild, nur so
        // weit nach unten wie noetig - nie ueber die harte Grenze hinaus.
        const maxScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        return Math.min(maxScroll, lower > upperSoft ? Math.min(lower, upperHard) : upperSoft);
      }

      alignViewport(target) {
        const next = this.targetScrollTop(target);
        if (next === null || Math.abs(next - window.scrollY) <= SCROLL_GAPS.tolerance) return;
        this.scrollWindowTo(next);
      }

      // Direktaufruf per URL (?category=..., mit oder ohne Sprungmarke #...-ankauf): Bei einer
      // Sprungmarke legt der Browser den Bereich anhand von scroll-margin-top an den oberen Rand,
      // ohne Sprungmarke bleibt die Seite oben. Damit das Ergebnis dem Klickweg entspricht, bekommt
      // der Zielbereich fuer den Ladevorgang eine aus Headerhoehe und Kopfblock berechnete Marge
      // (danach wieder der CSS-Wert), und die Lage wird nach dem Laden einmal ausgerichtet.
      // Bei Reload und Vor/Zurueck bleibt die vom Browser wiederhergestellte Scrollposition unangetastet.
      correctInitialScroll() {
        if (!this.selectedCategory) return;
        const target = this.categoryContents.find(content => content.dataset.categoryContent === this.selectedCategory);
        if (!target || !target.id) return;
        // Sprungmarke: Element-ID (z. B. #laptops-ankauf) oder die von updateUrl geschriebene Form
        // (z. B. #smartphones-ankauf); ohne Sprungmarke gilt der Kategorie-Parameter allein.
        // Fremde Sprungmarken bleiben dem Browser ueberlassen.
        const hash = window.location.hash;
        if (hash && hash !== `#${target.id}` && hash !== `#${this.selectedCategory}-ankauf`) return;
        const entry = typeof performance.getEntriesByType === 'function' ? performance.getEntriesByType('navigation')[0] : null;
        if (entry && (entry.type === 'reload' || entry.type === 'back_forward')) return;
        const headerBlock = target.querySelector('.smartphone-buyback__header');
        if (headerBlock && !target.hidden) {
          const offset = headerBlock.getBoundingClientRect().top - target.getBoundingClientRect().top;
          target.style.scrollMarginTop = `${Math.max(0, Math.round(this.stickyHeaderHeight() + SCROLL_GAPS.top - offset))}px`;
        }
        const initialRequest = this.watchDeferredInteraction();
        const initialCategory = this.selectedCategory;
        initialRequest.controller.signal.addEventListener('abort', () => { target.style.scrollMarginTop = ''; }, { once: true });
        const align = () => {
          if (initialRequest.generation !== this.interactionGeneration || !this.isConnected
            || this.selectedCategory !== initialCategory || window.location.hash !== hash) return;
          this.alignViewport(target);
        };
        window.requestAnimationFrame(align);
        const afterLoad = () => window.requestAnimationFrame(() => {
          align();
          window.requestAnimationFrame(() => { align(); initialRequest.controller.abort(); });
        });
        if (document.readyState === 'complete') afterLoad();
        else window.addEventListener('load', afterLoad, { once: true });
      }

      hideCategories() {
        this.categoryContents.forEach(content => {
          this.leaveContent(content);
          content.hidden = true;
          content.setAttribute('aria-hidden', 'true');
        });
      }

      showSubcategories({ focus = true } = {}) {
        this.selectedSummary.hidden = true;
        this.classList.remove('is-collapsed');
        this.mainHeader.hidden = true;
        this.mainCategories.hidden = true;
        this.subcategories.hidden = false;
        this.querySelector('[data-category="more"]')?.setAttribute('aria-expanded', 'true');
        if (focus) this.querySelector('[data-subcategory-back]')?.focus();
      }

      hideSubcategories() {
        this.expandSelection();
        this.subcategories.hidden = true;
        this.querySelector('[data-category="more"]')?.setAttribute('aria-expanded', 'false');
        this.selectCards(this.subcategoryCards, null);
      }

      resetSelection() {
        this.selectedCategory = null;
        this.selectCards(this.mainCards, null);
        this.hideCategories();
        this.hideSubcategories();
        this.expandSelection();
        this.setStatus('');
      }

      restoreSelectionFromUrl() {
        this.invalidateDeferredInteraction();
        const raw = new URL(window.location.href).searchParams.get('category') || '';
        const category = raw.replace(/[^a-z0-9_-]/gi, '');
        const card = this.querySelector(`[data-category="${category}"]`);
        if (card && ['smartphones', 'laptops', 'tablets'].includes(category)) {
          this.selectedCategory = category;
          this.selectCards(this.mainCards, card);
          this.hideSubcategories();
          this.showCategory(category);
          const labels = { smartphones: 'Smartphone-Ankauf', laptops: 'MacBook- & Laptop-Ankauf', tablets: 'Tablet-Ankauf' };
          this.collapseSelection(card.dataset.categoryLabel || labels[category]);
          return;
        }
        // Review 27.09. (F-044): "Weitere Elektronik" als eigener Schritt (?category=more) - Unterkategorien-Liste zeigen.
        const moreCard = category === 'more' ? this.querySelector('[data-category="more"]') : null;
        if (moreCard) {
          this.selectedCategory = 'more';
          this.selectCards(this.mainCards, moreCard);
          this.hideCategories();
          this.showSubcategories({ focus: false }); // Wiederherstellen (Laden, Zurueck/Vor): kein Fokussprung
          return;
        }
        const subcategoryCard = category ? this.querySelector(`[data-category-target="${category}"]`) : null;
        if (subcategoryCard && this.categoryContents.some(content => content.dataset.categoryContent === category)) {
          this.selectedCategory = category;
          this.selectCards(this.mainCards, this.querySelector('[data-category="more"]'));
          this.selectCards(this.subcategoryCards, subcategoryCard);
          this.showCategory(category);
          const label = subcategoryCard.dataset.categoryLabel || subcategoryCard.querySelector('.ivoodoo-selection-card__label')?.textContent?.trim() || 'Ankauf';
          this.collapseSelection(label);
          return;
        }
        this.resetSelection();
      }

      updateUrl(category) {
        const url = new URL(window.location.href);
        if (category) {
          url.searchParams.set('category', category);
          url.hash = category === 'more' ? '' : `${category}-ankauf`;
        } else {
          url.searchParams.delete('category');
          url.hash = '';
        }
        // Paket A / F-044 (27.09.2026): Jede Kategoriewahl bekommt einen eigenen Verlaufseintrag (vorher replaceState -
        // Browser-Zurueck verliess die Seite). Unveraenderte Adresse: kein neuer Eintrag.
        if (url.href === window.location.href) return;
        window.history.pushState({ ivSellCategory: category || '' }, '', url);
      }

      setStatus(message) {
        if (this.status) this.status.textContent = message;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smartphone-buyback"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('smartphone-buyback')) {
    customElements.define('smartphone-buyback', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.apiBase = this.dataset.apiBase.replace(/\/$/, '');
        this.catalog = null;
        this.selectedManufacturer = null;
        this.modelSelect = this.querySelector('[data-model]');
        this.modelCombobox = this.querySelector('[data-model-combobox]');
        this.modelTrigger = this.querySelector('[data-model-trigger]');
        this.modelValue = this.querySelector('[data-model-value]');
        this.modelPopover = this.querySelector('[data-model-popover]');
        this.modelListbox = this.querySelector('[data-model-listbox]');
        this.modelPlaceholder = this.modelValue.textContent;
        this.modelOptionElements = [];
        this.activeModelIndex = -1;
        this.brandIconTemplates = new Map(
          [...this.querySelectorAll('template[data-brand-icon-template]')]
            .map(template => [template.dataset.brandIconTemplate, template])
        );
        this.modelIconTemplates = new Map(
          [...this.querySelectorAll('template[data-model-icon-template]')]
            .map(template => [template.dataset.modelIconTemplate, template])
        );
        this.modelIconElement = this.querySelector('[data-model-icon]');
        this.storageSelect = this.querySelector('[data-storage]');
        this.storageWrap = this.querySelector('[data-storage-wrap]');
        this.storageOptionsBox = this.querySelector('[data-storage-options]');
        this.modelSearch = this.querySelector('[data-model-search]');
        this.modelEmpty = this.querySelector('[data-model-empty]');
        this.quoteButton = this.querySelector('[data-quote]');
        this.quoteButtonDefaultText = this.quoteButton.textContent;
        this.acceptButton = this.querySelector('[data-accept-offer]');
        this.status = this.querySelector('[data-status]');
        this.layoutElement = this.querySelector('.smartphone-buyback__layout');
        this.summaryElement = this.querySelector('.smartphone-buyback__summary');
        this.mobileSummary = this.querySelector('[data-mobile-summary]');
        this.mobileProgress = this.querySelector('[data-mobile-progress]');
        this.mobileDevice = this.querySelector('[data-mobile-device]');
        this.manualElement = this.querySelector('[data-manual-inquiry]');
        this.checkoutElement = this.querySelector('[data-checkout]');
        this.checkoutForm = this.querySelector('[data-checkout-form]');
        this.customerFields = this.querySelector('[data-customer-fields]');
        this.shippingFields = this.querySelector('[data-shipping-fields]');
        this.checkoutStatus = this.querySelector('[data-checkout-status]');
        this.checkoutSubmit = this.querySelector('[data-checkout-submit]');
        this.confirmationElement = this.querySelector('[data-confirmation]');
        this.currentQuote = null;
        this.idempotencyKey = '';
        this.submitting = false;
        this.modelSelect.addEventListener('change', () => {
          this.syncModelCombobox();
          this.selectModel();
        });
        this.modelTrigger.addEventListener('click', () => this.toggleModelList());
        this.modelTrigger.addEventListener('keydown', event => this.handleModelKeydown(event));
        this.modelListbox.addEventListener('click', event => {
          const option = event.target.closest('[role="option"][data-model-id]');
          if (option) this.chooseModel(option.dataset.modelId);
        });
        this.modelListbox.addEventListener('pointermove', event => {
          const option = event.target.closest('[role="option"][data-model-id]');
          const index = option ? this.modelOptionElements.indexOf(option) : -1;
          if (index >= 0 && index !== this.activeModelIndex) this.setActiveModelOption(index, false);
        });
        this.handleModelOutsidePointer = event => {
          if (!this.modelCombobox.contains(event.target)) this.closeModelList();
        };
        this.handleModelViewportChange = () => {
          if (!this.modelPopover.hidden) this.positionModelPopover();
        };
        document.addEventListener('pointerdown', this.handleModelOutsidePointer);
        window.addEventListener('resize', this.handleModelViewportChange);
        this.storageSelect.addEventListener('change', () => this.selectionChanged());
        this.storageSelect.addEventListener('change', () => this.syncStoragePills());
        this.storageOptionsBox.addEventListener('click', event => {
          const chip = event.target.closest('button[data-value]');
          if (!chip || this.storageSelect.disabled) return;
          this.storageSelect.value = chip.dataset.value;
          this.storageSelect.dispatchEvent(new Event('change', { bubbles: true }));
        });
        this.modelSearch.addEventListener('input', () => this.applyModelFilter(this.modelSearch.value));
        this.modelSearch.addEventListener('keydown', event => this.handleModelSearchKeydown(event));
        // Paket B / F-054: Escape schliesst die Liste ueberall darin; verlaesst der Tastaturfokus die Auswahl, schliesst sie.
        // (Nur bei bekanntem Ziel ausserhalb - ein Klick auf einen Listeneintrag hat kein relatedTarget und bleibt unberuehrt.)
        this.modelCombobox.addEventListener('keydown', event => {
          if (event.key === 'Escape' && !this.modelPopover.hidden) {
            event.preventDefault();
            this.closeModelList(true);
          }
        });
        this.modelCombobox.addEventListener('focusout', event => {
          if (event.relatedTarget && !this.modelCombobox.contains(event.relatedTarget) && !this.modelPopover.hidden) this.closeModelList();
        });
        this.renderStoragePills();
        this.querySelectorAll('[data-condition]').forEach(input => input.addEventListener('change', () => this.selectionChanged()));
        this.querySelectorAll('[data-detail]').forEach(input => input.addEventListener('change', () => this.selectionChanged()));
        this.querySelector('[data-summary-jump]')?.addEventListener('click', () => this.jumpToSummary());
        this.querySelectorAll('[data-open-manual-device]').forEach(button => button.addEventListener('click', () => this.openManualInquiry({ customDevice: true })));
        this.querySelector('[data-close-manual]')?.addEventListener('click', () => this.closeManualInquiry());
        this.manualElement?.addEventListener('change', event => {
          if (event.target.matches('[data-manual-display], [data-manual-function]')) this.pruefeAnkaufbar();
        });
        this.quoteButton.addEventListener('click', () => this.requestQuote());
        this.acceptButton.addEventListener('click', () => this.openCheckout());
        this.checkoutForm.addEventListener('change', event => {
          if (event.target.name === 'handoverMethod') this.handoverChanged();
          if (event.target.name === 'iban') this.syncIbanValidity(); // Review 27.09.: auch Werte ohne input-Ereignis (Passwortmanager)
          if (event.target.name === 'phone') this.syncPhoneValidity(); // Paket B / F-033
        });
        // Paket B / F-011 (27.09.2026): IBAN schon beim Eintippen pruefen (Feldzustand per setCustomValidity). Vorher lief die
        // Pruefung erst im Absende-Ablauf, NACH der gemeinsamen Formularpruefung (ivoodoo-forms.js) - die meldete deshalb
        // nichts: kein Sammelhinweis, kein Sprung, Fokus blieb auf dem Knopf (mobil lag die Meldung oberhalb des Bildes).
        // capture: der Zustand steht, bevor ivoodoo-forms.js das Feld bewertet.
        this.checkoutForm.addEventListener('input', event => {
          if (event.target.name === 'iban') this.syncIbanValidity();
          if (event.target.name === 'phone') this.syncPhoneValidity(); // Paket B / F-033
        }, true);
        // Paket B / F-033: reset() leert die Felder, aber nicht setCustomValidity - danach neu bewerten.
        this.checkoutForm.addEventListener('reset', () => window.setTimeout(() => this.syncPhoneValidity(), 0));
        this.checkoutForm.addEventListener('submit', event => this.submitPurchaseRequest(event));
        this.querySelector('[data-start-over]').addEventListener('click', () => this.startOver());
        if (this.querySelector('[data-manual-success]')) this.openManualInquiry({ fromSuccess: true });
        this.ansageRegion(); // Paket B / F-050: Ansage-Region vor der ersten Ansage anlegen
        this.loadCatalog();
        this.updateMobileSummary();
      }

      async loadCatalog() {
        try {
          const response = await this.fetchJson(`${this.apiBase}/catalog`, { headers: { Accept: 'application/json' } });
          const data = await response.json();
          if (!response.ok) {
            const fehler = new Error('http ' + response.status);
            fehler.status = response.status;
            fehler.serverMessage = typeof data.error === 'string' ? data.error : '';
            throw fehler;
          }
          this.removeAttribute('data-catalog-failed');
          this.catalog = data;
          this.renderBrands();
          this.querySelector('[data-brands]').removeAttribute('data-loading');
        } catch (error) {
          // Der Hinweiskasten mit "Erneut versuchen" gehoert zu Schritt 1 und wird von
          // ivoodoo-forms.js an diesem Attribut aufgebaut. Die Statuszeile der
          // Angebotsuebersicht bleibt dann leer, damit nicht zwei Flaechen widersprechen.
          this.setAttribute('data-catalog-failed', '');
          const text = this.humanError(error, this.dataset.catalogError);
          this.setStatus(window.ivFormsReady ? '' : text, true);
          // Block H: Der Leerzustand ("kein Sofortpreis") passt nicht zu einer Stoerung - der
          // Hinweiskasten traegt Satz und Weg allein.
          this.querySelector('[data-catalog-empty]').hidden = true;
          this.querySelector('[data-brands]').removeAttribute('data-loading');
        }
      }

      renderBrands() {
        const container = this.querySelector('[data-brands]');
        container.replaceChildren();
        const manufacturers = Array.isArray(this.catalog?.manufacturers) ? this.catalog.manufacturers : [];
        this.querySelector('[data-catalog-empty]').hidden = manufacturers.length > 0;
        manufacturers.forEach(manufacturer => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'smartphone-buyback__brand ivoodoo-selection-card';
          button.setAttribute('aria-pressed', 'false');
          button.dataset.manufacturer = manufacturer.name;
          const iconKey = String(manufacturer.name || '').trim().toLowerCase();
          const iconTemplate = this.brandIconTemplates.get(iconKey);
          if (iconTemplate) {
            button.append(iconTemplate.content.cloneNode(true));
          } else {
            const icon = document.createElement('span');
            icon.className = 'ivoodoo-selection-card__icon ivoodoo-selection-card__icon--fallback';
            icon.setAttribute('aria-hidden', 'true');
            const fallback = document.createElement('span');
            fallback.className = 'ivoodoo-selection-card__fallback';
            fallback.textContent = String(manufacturer.name || '?').trim().charAt(0) || '?';
            icon.append(fallback);
            button.append(icon);
          }
          const label = document.createElement('span');
          label.className = 'ivoodoo-selection-card__label';
          label.textContent = manufacturer.name;
          const check = document.createElement('span');
          check.className = 'ivoodoo-selection-card__check';
          check.setAttribute('aria-hidden', 'true');
          check.textContent = '✓';
          button.append(label, check);
          button.addEventListener('click', () => this.selectManufacturer(manufacturer, button));
          container.append(button);
        });
      }

      selectManufacturer(manufacturer, button) {
        this.closeModelList();
        this.selectedManufacturer = manufacturer;
        const iconKey = String(manufacturer.name || '').trim().toLowerCase();
        const modelIconTemplate = this.modelIconTemplates.get(iconKey);
        if (modelIconTemplate) this.modelIconElement.replaceChildren(modelIconTemplate.content.cloneNode(true));
        this.querySelectorAll('[data-manufacturer]').forEach(item => {
          const selected = item === button;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        this.resetSelect(this.modelSelect);
        const models = Array.isArray(manufacturer.models) ? manufacturer.models : [];
        models.forEach(model => this.addOption(this.modelSelect, String(model.id), model.name));
        this.modelSelect.disabled = models.length === 0;
        this.modelTrigger.disabled = models.length === 0;
        this.renderModelOptions(models);
        this.resetSelect(this.storageSelect);
        this.storageSelect.disabled = true;
        this.renderStoragePills();
        this.selectionChanged();
      }

      selectModel() {
        const model = this.currentModel();
        this.syncModelCombobox();
        this.resetSelect(this.storageSelect);
        if (model) {
          model.storages.forEach(storage => this.addOption(this.storageSelect, String(storage.priceId), storage.label));
          this.storageSelect.disabled = false;
        } else {
          this.storageSelect.disabled = true;
        }
        this.renderStoragePills();
        this.selectionChanged();
      }

      renderModelOptions(models) {
        this.modelListbox.replaceChildren();
        this.modelOptionElements = [];
        this.activeModelIndex = -1;
        const groups = this.groupModels(models);

        groups.forEach((group, groupIndex) => {
          const section = document.createElement('section');
          section.className = 'smartphone-buyback__model-group';
          const title = document.createElement('p');
          title.className = 'smartphone-buyback__model-group-title';
          title.id = `${this.modelListbox.id}-group-${groupIndex}`;
          title.textContent = group.label;
          const options = document.createElement('div');
          options.className = 'smartphone-buyback__model-options';
          options.setAttribute('role', 'group');
          options.setAttribute('aria-labelledby', title.id);

          group.models.forEach(model => {
            const option = document.createElement('div');
            const safeId = String(model.id).replace(/[^a-zA-Z0-9_-]/g, '-');
            option.className = 'smartphone-buyback__model-option';
            option.id = `${this.modelListbox.id}-option-${safeId}`;
            option.dataset.modelId = String(model.id);
            option.setAttribute('role', 'option');
            option.setAttribute('aria-selected', 'false');
            const radio = document.createElement('span');
            radio.className = 'smartphone-buyback__model-option-radio';
            radio.setAttribute('aria-hidden', 'true');
            const label = document.createElement('span');
            label.className = 'smartphone-buyback__model-option-label';
            label.textContent = model.name;
            const check = document.createElement('span');
            check.className = 'smartphone-buyback__model-option-check';
            check.setAttribute('aria-hidden', 'true');
            check.textContent = '✓';
            option.append(radio, label, check);
            options.append(option);
            this.modelOptionElements.push(option);
          });

          section.append(title, options);
          this.modelListbox.append(section);
        });

        if (this.modelSearch) this.modelSearch.value = '';
        this.applyModelFilter('');
        this.syncModelCombobox();
      }

      groupModels(models) {
        let previousGeneration = '';
        const prepared = models.map((model, index) => {
          let generation = this.extractModelGeneration(model.name);
          if (!generation) {
            generation = previousGeneration || models.slice(index + 1)
              .map(candidate => this.extractModelGeneration(candidate.name))
              .find(Boolean) || '';
          }
          if (generation) previousGeneration = generation;
          return { model, generation };
        });
        const grouped = new Map();

        prepared.forEach(({ model, generation }) => {
          const key = generation || 'models';
          if (!grouped.has(key)) grouped.set(key, { label: this.modelSeriesLabel(generation), models: [] });
          grouped.get(key).models.push(model);
        });

        return Array.from(grouped.values());
      }

      extractModelGeneration(modelName) {
        const name = String(modelName || '');
        const patterns = [/^iPhone\s+(\d{2})(?:\D|$)/i, /^Pixel\s+(\d{1,2})(?:\D|$)/i, /^Galaxy\s+S(\d{1,2})(?:\D|$)/i];
        for (const pattern of patterns) {
          const match = name.match(pattern);
          if (match) return match[1];
        }
        return name.match(/\b(\d{1,3})\b/)?.[1] || '';
      }

      modelSeriesLabel(generation) {
        const manufacturer = this.selectedManufacturer?.name || '';
        if (!generation) return manufacturer ? `${manufacturer} Modelle` : 'Modelle';
        if (manufacturer === 'Apple') return `iPhone ${generation} Serie`;
        if (manufacturer === 'Google') return `Pixel ${generation} Serie`;
        if (manufacturer === 'Samsung') return `Galaxy S${generation} Serie`;
        return `${manufacturer} ${generation} Serie`.trim();
      }

      syncModelCombobox() {
        const model = this.currentModel();
        this.modelValue.textContent = model?.name || this.modelPlaceholder;
        this.modelOptionElements.forEach(option => {
          const selected = Boolean(model) && option.dataset.modelId === String(model.id);
          option.classList.toggle('is-selected', selected);
          option.setAttribute('aria-selected', selected ? 'true' : 'false');
        });
      }

      toggleModelList() {
        if (this.modelPopover.hidden) this.openModelList();
        else this.closeModelList();
      }

      openModelList(preferred = 'selected') {
        if (this.modelTrigger.disabled || this.modelOptionElements.length === 0) return;
        this.modelPopover.hidden = false;
        this.modelCombobox.classList.add('is-open');
        this.modelTrigger.setAttribute('aria-expanded', 'true');
        this.positionModelPopover();
        if (this.modelSearch && window.matchMedia('(hover: hover) and (pointer: fine)').matches) this.modelSearch.focus();
        const visible = this.visibleModelIndexes();
        if (!visible.length) return;
        const selectedIndex = visible.find(index => this.modelOptionElements[index].classList.contains('is-selected'));
        const initialIndex = selectedIndex !== undefined ? selectedIndex : preferred === 'end' ? visible[visible.length - 1] : visible[0];
        this.setActiveModelOption(initialIndex);
      }

      closeModelList(returnFocus = false) {
        if (!this.modelPopover.hidden) this.modelPopover.hidden = true;
        this.modelCombobox.classList.remove('is-open', 'opens-upward');
        this.modelTrigger.setAttribute('aria-expanded', 'false');
        this.modelTrigger.removeAttribute('aria-activedescendant');
        this.modelOptionElements.forEach(option => option.classList.remove('is-active'));
        this.activeModelIndex = -1;
        if (this.modelSearch && this.modelSearch.value) {
          this.modelSearch.value = '';
          this.applyModelFilter('');
        }
        if (returnFocus) this.modelTrigger.focus();
      }

      positionModelPopover() {
        if (this.modelPopover.hidden) return;
        const triggerRect = this.modelTrigger.getBoundingClientRect();
        const gap = 8;
        const spaceBelow = window.innerHeight - triggerRect.bottom - gap;
        const spaceAbove = triggerRect.top - gap;
        const desiredHeight = Math.min(this.modelPopover.scrollHeight, 480);
        const opensUpward = spaceBelow < Math.min(desiredHeight, 300) && spaceAbove > spaceBelow;
        const availableSpace = Math.max(140, Math.floor((opensUpward ? spaceAbove : spaceBelow) - 4));
        this.modelCombobox.classList.toggle('opens-upward', opensUpward);
        this.modelPopover.style.setProperty('--model-popover-max-height', `${Math.min(480, availableSpace)}px`);
      }

      setActiveModelOption(index, scroll = true) {
        if (!this.modelOptionElements.length) return;
        const normalizedIndex = Math.max(0, Math.min(index, this.modelOptionElements.length - 1));
        this.activeModelIndex = normalizedIndex;
        this.modelOptionElements.forEach((option, optionIndex) => option.classList.toggle('is-active', optionIndex === normalizedIndex));
        const activeOption = this.modelOptionElements[normalizedIndex];
        this.modelTrigger.setAttribute('aria-activedescendant', activeOption.id);
        if (this.modelSearch) this.modelSearch.setAttribute('aria-activedescendant', activeOption.id);
        if (scroll) activeOption.scrollIntoView({ block: 'nearest' });
      }

      visibleModelIndexes() {
        return this.modelOptionElements.reduce((indexes, option, index) => {
          if (!option.hidden) indexes.push(index);
          return indexes;
        }, []);
      }

      moveActiveModelOption(delta) {
        const visible = this.visibleModelIndexes();
        if (!visible.length) return;
        const position = visible.indexOf(this.activeModelIndex);
        const nextPosition = position < 0 ? (delta > 0 ? 0 : visible.length - 1) : Math.max(0, Math.min(visible.length - 1, position + delta));
        this.setActiveModelOption(visible[nextPosition]);
      }

      applyModelFilter(query) {
        const term = String(query || '').trim().toLowerCase();
        let visibleCount = 0;
        this.modelOptionElements.forEach(option => {
          const match = !term || option.textContent.toLowerCase().includes(term);
          option.hidden = !match;
          if (match) visibleCount += 1;
          else option.classList.remove('is-active');
        });
        this.modelListbox.querySelectorAll('.smartphone-buyback__model-group').forEach(group => {
          group.hidden = !group.querySelector('.smartphone-buyback__model-option:not([hidden])');
        });
        if (this.modelEmpty) this.modelEmpty.hidden = visibleCount > 0;
        if (this.activeModelIndex >= 0 && this.modelOptionElements[this.activeModelIndex]?.hidden) this.activeModelIndex = -1;
        if (!this.modelPopover.hidden) this.positionModelPopover();
      }

      handleModelSearchKeydown(event) {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          this.moveActiveModelOption(1);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          this.moveActiveModelOption(-1);
        } else if (event.key === 'Enter') {
          event.preventDefault();
          const visible = this.visibleModelIndexes();
          const targetIndex = this.activeModelIndex >= 0 && !this.modelOptionElements[this.activeModelIndex]?.hidden
            ? this.activeModelIndex
            : visible.length === 1 ? visible[0] : -1;
          if (targetIndex >= 0) this.chooseModel(this.modelOptionElements[targetIndex].dataset.modelId);
        } else if (event.key === 'Escape') {
          event.preventDefault();
          this.closeModelList(true);
        } else if (event.key === 'Tab') {
          // Paket B / F-054 (27.09.2026): Tab verlaesst die Liste - sie schliesst, statt offen den naechsten Knopf zu verdecken.
          this.closeModelList();
        }
      }

      renderStoragePills() {
        if (!this.storageOptionsBox) return;
        const options = Array.from(this.storageSelect.options).slice(1);
        this.storageOptionsBox.replaceChildren();
        const active = options.length > 0 && !this.storageSelect.disabled;
        this.storageOptionsBox.hidden = !active;
        if (this.storageWrap) this.storageWrap.classList.toggle('is-replaced-by-pills', active);
        if (!active) return;
        options.forEach(option => {
          const chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'smartphone-buyback__storage-chip';
          chip.dataset.value = option.value;
          chip.setAttribute('aria-pressed', 'false');
          const check = document.createElement('span');
          check.className = 'smartphone-buyback__storage-chip-check';
          check.setAttribute('aria-hidden', 'true');
          check.textContent = '✓';
          const label = document.createElement('span');
          label.textContent = option.textContent;
          chip.append(check, label);
          this.storageOptionsBox.append(chip);
        });
        this.syncStoragePills();
      }

      syncStoragePills() {
        if (!this.storageOptionsBox) return;
        this.storageOptionsBox.querySelectorAll('button[data-value]').forEach(chip => {
          const selected = chip.dataset.value === this.storageSelect.value;
          chip.classList.toggle('is-selected', selected);
          chip.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
      }

      chooseModel(modelId) {
        const nativeOption = Array.from(this.modelSelect.options).find(option => option.value === String(modelId));
        if (!nativeOption) return;
        this.modelSelect.value = nativeOption.value;
        this.modelSelect.dispatchEvent(new Event('change', { bubbles: true }));
        this.closeModelList(true);
      }

      handleModelKeydown(event) {
        const isOpen = !this.modelPopover.hidden;
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          if (!isOpen) this.openModelList('start');
          else this.moveActiveModelOption(1);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          if (!isOpen) this.openModelList('end');
          else this.moveActiveModelOption(-1);
        } else if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
          event.preventDefault();
          if (!isOpen) this.openModelList();
          else if (this.activeModelIndex >= 0) this.chooseModel(this.modelOptionElements[this.activeModelIndex].dataset.modelId);
        } else if (event.key === 'Escape' && isOpen) {
          event.preventDefault();
          this.closeModelList(true);
        } else if (event.key === 'Home' && isOpen) {
          event.preventDefault();
          const visibleForHome = this.visibleModelIndexes();
          if (visibleForHome.length) this.setActiveModelOption(visibleForHome[0]);
        } else if (event.key === 'End' && isOpen) {
          event.preventDefault();
          const visibleForEnd = this.visibleModelIndexes();
          if (visibleForEnd.length) this.setActiveModelOption(visibleForEnd[visibleForEnd.length - 1]);
        } else if (event.key === 'Tab' && isOpen) {
          this.closeModelList();
        }
      }

      resetSelect(select) {
        while (select.options.length > 1) select.remove(1);
        select.selectedIndex = 0;
      }

      addOption(select, value, label) {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = label;
        select.append(option);
      }

      currentModel() {
        return this.selectedManufacturer?.models.find(model => String(model.id) === this.modelSelect.value) || null;
      }

      currentStorage() {
        return this.currentModel()?.storages.find(storage => String(storage.priceId) === this.storageSelect.value) || null;
      }

      currentCondition() {
        return this.querySelector('[data-condition]:checked')?.value || '';
      }

      currentDetail(name) {
        return this.querySelector(`[data-detail="${name}"]:checked`)?.value || '';
      }

      selectedInputLabel(selector) {
        const input = this.querySelector(selector);
        return input?.nextElementSibling?.querySelector('strong')?.textContent?.trim() || '';
      }

      completeSelection() {
        return Boolean(
          this.selectedManufacturer && this.currentModel() && this.currentStorage() && this.currentCondition()
        );
      }

      usesAutomaticPrice() {
        const condition = this.currentCondition();
        if (condition === 'neu' || condition === 'wie_neu') return true;
        if (condition === 'sehr_gut') {
          const apiConditions = Array.isArray(this.catalog?.conditions) ? this.catalog.conditions : [];
          if (!apiConditions.some(entry => entry.id === 'sehr_gut')) return false;
          return true;
        }
        return false;
      }

      updateMobileSummary() {
        const model = this.currentModel();
        const storage = this.currentStorage();
        const values = [
          this.selectedManufacturer,
          model,
          storage,
          this.currentCondition(),
        ];
        const remaining = values.filter(value => !value).length;
        const device = [model?.name || this.selectedManufacturer?.name, storage?.label].filter(Boolean).join(' · ');
        this.mobileDevice.textContent = device || 'Smartphone auswählen';
        // Paket B / F-032 (27.09.2026): Begriffe wie die Preisbox ("Ankaufspreis"); ohne Sofortpreis wie die Anfrage.
        this.mobileProgress.textContent = remaining
          ? `${remaining} ${remaining === 1 ? 'Angabe' : 'Angaben'} bis zum Ankaufspreis`
          : this.usesAutomaticPrice() ? 'Ankaufspreis kann berechnet werden' : 'Individuelles Angebot – nach Prüfung';
      }

      selectionChanged() {
        const model = this.currentModel();
        const storage = this.currentStorage();
        const conditionInput = this.querySelector('[data-condition]:checked');
        this.setText('[data-summary-brand]', this.selectedManufacturer?.name || '—');
        this.setText('[data-summary-model]', model?.name || '—');
        this.setText('[data-summary-storage]', storage?.label || '—');
        this.setText('[data-summary-condition]', conditionInput?.nextElementSibling?.querySelector('strong')?.textContent || '—');
        const complete = this.completeSelection();
        this.quoteButton.disabled = !complete;
        this.quoteButton.textContent = complete && !this.usesAutomaticPrice()
          ? 'Individuelles Angebot anfragen'
          : this.quoteButtonDefaultText;
        this.resetCheckoutState();
        this.updateMobileSummary();
        this.setStatus(complete && !this.usesAutomaticPrice()
          ? 'Diese Auswahl prüfen wir persönlich und melden uns mit einem individuellen Angebot.'
          : '');
      }

      async requestQuote() {
        if (!this.completeSelection()) return;
        if (!this.usesAutomaticPrice()) {
          this.openManualInquiry();
          return;
        }
        const storage = this.currentStorage();
        const condition = this.currentCondition();
        if (!storage || !condition) return;
        this.quoteButton.disabled = true;
        this.quoteButton.setAttribute('aria-busy', 'true');
        this.quoteButton.textContent = 'Ankaufspreis wird berechnet …'; // Paket B / F-032
        this.setStatus('');
        try {
          const response = await this.fetchJson(`${this.apiBase}/quote`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ priceId: storage.priceId, condition })
          });
          const quote = await response.json();
          if (!response.ok) {
            const fehler = new Error('http ' + response.status);
            fehler.status = response.status;
            fehler.serverMessage = typeof quote.error === 'string' ? quote.error : '';
            throw fehler;
          }
          if (String(storage.priceId) !== this.storageSelect.value || condition !== this.currentCondition()) return;
          this.setText('[data-summary-brand]', quote.manufacturer);
          this.setText('[data-summary-model]', quote.model);
          this.setText('[data-summary-storage]', quote.storage);
          // Paket B / F-032 (27.09.2026): Zustand bleibt wie gewaehlt ("Neu (versiegelt)") - die Preisabfrage liefert nur "Neu".
          this.setText('[data-summary-price]', quote.formattedPrice);
          this.querySelector('[data-offer]').hidden = false;
          this.currentQuote = { ...quote, priceId: storage.priceId, condition };
          this.quoteButton.hidden = true;
          this.acceptButton.hidden = false;
          // Block H (12.09.2026, Punkt 2): die einzige dauerhaft sichtbare Preisaussage mobil traegt den Vorbehalt im Wort.
          this.mobileProgress.textContent = `Vorläufig: ${quote.formattedPrice}`;
          // Paket B / F-050 (27.09.2026): Preis fuer Screenreader ansagen und Fokus auf den naechsten Schritt - vorher fiel er
          // auf die Seite, weil der gedrueckte Knopf verschwindet.
          this.ansagen(`Vorläufiger Ankaufspreis: ${quote.formattedPrice}`);
          this.fokusWeiter();
        } catch (error) {
          // Block H (12.09.2026, Gegenpruefung): Eine abgebrochene Abfrage fuer eine inzwischen geaenderte Auswahl
          // darf das neue Angebot nicht zuruecksetzen (wie in ivoodoo-device-buyback.js).
          if (String(storage.priceId) !== this.storageSelect.value || condition !== this.currentCondition()) return;
          const meldung = this.humanError(error, this.dataset.quoteError);
          this.setStatus(meldung, true, meldung === this.dataset.quoteError ? () => this.requestQuote() : null);
          this.resetCheckoutState();
          this.mobileProgress.textContent = 'Preis gerade nicht verfügbar';
        } finally {
          this.quoteButton.disabled = !this.completeSelection();
          this.quoteButton.removeAttribute('aria-busy');
          this.quoteButton.textContent = this.completeSelection() && !this.usesAutomaticPrice()
            ? 'Individuelles Angebot anfragen'
            : this.quoteButtonDefaultText;
        }
      }

      resetCheckoutState() {
        this.currentQuote = null;
        this.idempotencyKey = '';
        this.querySelector('[data-offer]').hidden = true;
        this.quoteButton.hidden = false;
        this.acceptButton.hidden = true;
        this.checkoutElement.hidden = true;
        this.customerFields.hidden = true;
        this.shippingFields.hidden = true;
        this.checkoutForm.reset();
        this.querySelectorAll('[data-shipping-required]').forEach(field => { field.required = false; });
        this.checkoutStatus.className = 'smartphone-buyback__status';
        this.checkoutStatus.textContent = '';
      }

      jumpToSummary() {
        const target = this.manualElement.hidden ? this.summaryElement : this.manualElement;
        target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      manualField(selector) {
        return this.manualElement.querySelector(selector);
      }

      setManualField(selector, value) {
        const field = this.manualField(selector);
        if (field) field.value = value || '';
      }

      detailManualLabel(name) {
        const labels = {
          display: { intact: 'Einwandfrei', scratched: 'Kratzer', broken: 'Displaybruch / Bildfehler', unknown: 'Unbekannt' },
          battery: { good: 'Gut / normale Laufzeit', weak: 'Schwach / Servicehinweis', unknown: 'Unbekannt' },
          function: { full: 'Alles funktioniert', limited: 'Mindestens eine Einschränkung', defect: 'Nicht funktionsfähig', unknown: 'Unbekannt' },
        };
        return labels[name]?.[this.currentDetail(name)] || '';
      }

      openManualInquiry({ customDevice = false, fromSuccess = false } = {}) {
        this.closeModelList();
        if (!fromSuccess) {
          const conditionLabel = this.selectedInputLabel('[data-condition]:checked');
          this.setManualField('[data-manual-brand]', this.selectedManufacturer?.name || '');
          this.setManualField('[data-manual-model]', customDevice ? '' : this.currentModel()?.name || '');
          this.setManualField('[data-manual-storage]', customDevice ? '' : this.currentStorage()?.label || '');
          this.setManualField('[data-manual-condition-select]', conditionLabel);
          this.setManualField('[data-manual-display]', this.detailManualLabel('display'));
          this.setManualField('[data-manual-battery]', this.detailManualLabel('battery'));
          this.setManualField('[data-manual-function]', this.detailManualLabel('function'));
        }
        this.layoutElement.hidden = true;
        this.mobileSummary.hidden = true;
        this.checkoutElement.hidden = true;
        this.manualElement.hidden = false;
        this.manualElement.scrollIntoView({ behavior: fromSuccess ? 'auto' : 'smooth', block: 'start' });
        this.pruefeAnkaufbar();
        if (!fromSuccess) {
          const firstEmpty = [...this.manualElement.querySelectorAll('input[required],select[required]')].find(field => !field.value);
          if (firstEmpty) setTimeout(() => firstEmpty.focus(), 180);
        }
      }

      // Nicht ankaufbare Zustaende (Ankaufbedingungen Ziffer 4): Hinweis zeigen, Absenden sperren.
      pruefeAnkaufbar() {
        const gesperrt = ['Displaybruch / Bildfehler', 'Nicht funktionsfähig'];
        const werte = ['[data-manual-display]', '[data-manual-function]'].map(sel => this.manualField(sel)?.value || '');
        const blockiert = werte.some(wert => gesperrt.includes(wert));
        const hinweis = this.manualField('[data-manual-block]');
        const senden = this.manualField('.smartphone-buyback__manual-submit');
        if (hinweis) hinweis.hidden = !blockiert;
        if (senden) senden.disabled = blockiert;
        return blockiert;
      }

      closeManualInquiry() {
        this.manualElement.hidden = true;
        this.layoutElement.hidden = false;
        this.mobileSummary.hidden = false;
        this.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      openCheckout() {
        const storage = this.currentStorage();
        const condition = this.currentCondition();
        if (!this.currentQuote || !storage || String(this.currentQuote.priceId) !== String(storage.priceId) || this.currentQuote.condition !== condition) {
          this.setStatus('Bitte berechne den Ankaufspreis erneut.', true); // Paket B / F-032
          return;
        }
        this.checkoutForm.reset();
        this.idempotencyKey = this.createIdempotencyKey();
        this.customerFields.hidden = true;
        this.shippingFields.hidden = true;
        this.querySelectorAll('[data-shipping-required]').forEach(field => { field.required = false; });
        this.checkoutStatus.className = 'smartphone-buyback__status';
        this.checkoutStatus.textContent = '';
        this.updateReview();
        this.checkoutElement.hidden = false;
        this.checkoutElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        const firstHandover = this.checkoutForm.querySelector('input[name="handoverMethod"]');
        if (firstHandover) setTimeout(() => firstHandover.focus(), 180);
      }

      handoverChanged() {
        const handover = this.checkoutForm.elements.handoverMethod.value;
        const shipping = handover === 'shipping';
        this.customerFields.hidden = !handover;
        this.shippingFields.hidden = !shipping;
        this.querySelectorAll('[data-shipping-required]').forEach(field => { field.required = shipping; });
        this.syncIbanValidity(); // Paket B / F-011: ohne Versand keine IBAN-Pruefung, mit Versand sofort
        this.updateReview();
        if (handover) {
          const firstName = this.checkoutForm.elements.firstName;
          if (firstName) setTimeout(() => firstName.focus(), 80);
        }
      }

      updateReview() {
        if (!this.currentQuote) return;
        const handover = this.checkoutForm.elements.handoverMethod.value;
        this.setText('[data-review-brand]', this.currentQuote.manufacturer);
        this.setText('[data-review-model]', this.currentQuote.model);
        this.setText('[data-review-storage]', this.currentQuote.storage);
        this.setText('[data-review-condition]', this.querySelector('[data-condition]:checked')?.nextElementSibling?.querySelector('strong')?.textContent?.trim() || this.currentQuote.conditionLabel); // Paket B / F-032
        this.setText('[data-review-price]', this.currentQuote.formattedPrice);
        this.setText('[data-review-handover]', handover === 'shipping' ? 'Kostenlos mit DHL einsenden' : handover === 'store' ? 'Persönliche Abgabe in Köln-Ehrenfeld' : '—');
      }

      createIdempotencyKey() {
        if (globalThis.crypto?.randomUUID) return crypto.randomUUID();
        const bytes = new Uint8Array(24);
        globalThis.crypto.getRandomValues(bytes);
        return Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('');
      }

      normalizeIban(value) {
        return String(value || '').replace(/\s+/g, '').toUpperCase();
      }

      // Paket B / F-011: Gueltigkeit der IBAN als Feldzustand - so kennt jede Formularpruefung sie (Sammelhinweis, Sprung, Fokus).
      // Leeres Feld bleibt Sache von "required" (Pflichtfeld-Meldung).
      syncIbanValidity() {
        const iban = this.checkoutForm?.elements.iban;
        if (!iban) return;
        const shipping = this.checkoutForm.elements.handoverMethod.value === 'shipping';
        const value = iban.value.trim();
        iban.setCustomValidity(shipping && value && !this.isPlausibleIban(value) ? 'Bitte gib eine gültige IBAN ein.' : '');
      }

      // Paket B / F-033 (27.09.2026): einfache Plausibilitaet der Telefonnummer - nur Ziffern, Leerzeichen und + ( ) / - . sowie
      // 6 bis 17 Ziffern. Als Feldzustand wie die IBAN; ein leeres Feld bleibt Sache von "required".
      syncPhoneValidity() {
        const phone = this.checkoutForm?.elements.phone;
        if (!phone) return;
        const value = phone.value.trim();
        phone.setCustomValidity(value && !this.isPlausiblePhone(value) ? 'Bitte gib eine gültige Telefonnummer ein.' : '');
      }

      // Review 27.09.: Aus Kontakten kopierte Nummern tragen unsichtbare Richtungszeichen (iPhone), dazu geschuetzte bzw.
      // typografische Striche und "(+49)" - alles zulassen, sonst waere z. B. der Smartphone-Auftrag grundlos blockiert.
      isPlausiblePhone(value) {
        const text = String(value || '').replace(/[\u200B-\u200F\u202A-\u202E\u2060-\u2069\uFEFF]/g, '').replace(/[\u2010-\u2015\u2212]/g, '-').trim();
        const ziffern = text.replace(/\D/g, '').length;
        return /^[\d\s()\/.+-]+$/.test(text) && (text.match(/\+/g) || []).length <= 1 && ziffern >= 6 && ziffern <= 17;
      }

      isPlausibleIban(value) {
        const iban = this.normalizeIban(value);
        if (!/^[A-Z]{2}[0-9]{2}[A-Z0-9]{11,30}$/.test(iban)) return false;
        const rearranged = iban.slice(4) + iban.slice(0, 4);
        let remainder = 0;
        for (const character of rearranged) {
          const digits = /[A-Z]/.test(character) ? String(character.charCodeAt(0) - 55) : character;
          for (const digit of digits) remainder = (remainder * 10 + Number(digit)) % 97;
        }
        return remainder === 1;
      }

      async submitPurchaseRequest(event) {
        event.preventDefault();
        if (this.submitting || !this.currentQuote) return;
        const form = this.checkoutForm;
        const handoverMethod = form.elements.handoverMethod.value;
        this.checkoutStatus.className = 'smartphone-buyback__status';
        this.checkoutStatus.textContent = '';
        const ibanInput = form.elements.iban;
        ibanInput.setCustomValidity('');
        if (handoverMethod === 'shipping' && !this.isPlausibleIban(ibanInput.value)) {
          ibanInput.setCustomValidity('Bitte gib eine gültige IBAN ein.');
        }
        this.syncPhoneValidity(); // Paket B / F-033
        if (!form.reportValidity()) {
          // Paket B / F-011: Rueckfall (z. B. ohne ivoodoo-forms.js) - zum ersten fehlerhaften Feld und Fokus dorthin.
          const erstes = form.querySelector(':invalid');
          if (erstes) {
            erstes.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
            erstes.focus({ preventScroll: true });
          }
          return;
        }
        const fields = new FormData(form);
        const storage = this.currentStorage();
        const condition = this.currentCondition();
        if (!storage || String(this.currentQuote.priceId) !== String(storage.priceId) || this.currentQuote.condition !== condition) {
          this.checkoutStatus.classList.add('is-error');
          this.checkoutStatus.textContent = 'Deine Auswahl hat sich geändert. Bitte berechne den Ankaufspreis erneut.';
          return;
        }
        const shipping = handoverMethod === 'shipping';
        const payload = {
          priceId: storage.priceId,
          condition,
          idempotencyKey: this.idempotencyKey,
          firstName: String(fields.get('firstName') || '').trim(),
          lastName: String(fields.get('lastName') || '').trim(),
          email: String(fields.get('email') || '').trim(),
          phone: String(fields.get('phone') || '').trim(),
          handoverMethod,
          address: shipping ? {
            street: String(fields.get('street') || '').trim(),
            houseNumber: String(fields.get('houseNumber') || '').trim(),
            postalCode: String(fields.get('postalCode') || '').trim(),
            city: String(fields.get('city') || '').trim(),
            country: 'Deutschland'
          } : { country: 'Deutschland' },
          bank: shipping ? {
            accountHolder: String(fields.get('accountHolder') || '').trim(),
            iban: this.normalizeIban(fields.get('iban'))
          } : {},
          legalAccepted: fields.has('privacyAccepted') && fields.has('termsAccepted'),
          website: String(fields.get('website') || '')
        };
        this.submitting = true;
        this.checkoutSubmit.disabled = true;
        this.checkoutSubmit.setAttribute('aria-busy', 'true');
        this.checkoutSubmit.textContent = 'Verkaufsauftrag wird gesendet …';
        try {
          const response = await this.fetchJson(`${this.apiBase}/purchase-requests`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload)
          }, 60000);
          const data = await response.json();
          if (!response.ok) {
            const fehler = new Error('http ' + response.status);
            fehler.status = response.status;
            fehler.serverMessage = typeof data.error === 'string' ? data.error : '';
            throw fehler;
          }
          this.showConfirmation(data);
        } catch (error) {
          this.checkoutStatus.classList.add('is-error');
          this.checkoutStatus.textContent = this.humanError(error, this.dataset.submitError);
        } finally {
          this.submitting = false;
          this.checkoutSubmit.disabled = false;
          this.checkoutSubmit.removeAttribute('aria-busy');
          this.checkoutSubmit.textContent = 'Verkaufsauftrag verbindlich absenden';
        }
      }

      showConfirmation(data) {
        const handoverMethod = data.handoverMethod || this.checkoutForm.elements.handoverMethod.value;
        const device = `${data.manufacturer || this.currentQuote.manufacturer} ${data.model || this.currentQuote.model}, ${data.storage || this.currentQuote.storage}`;
        this.setText('[data-confirmation-id]', data.requestId || '—');
        this.setText('[data-confirmation-device]', device);
        this.setText('[data-confirmation-price]', data.formattedPrice || this.currentQuote.formattedPrice);
        this.setText('[data-confirmation-handover]', handoverMethod === 'shipping' ? 'Kostenlos mit DHL einsenden' : 'Persönliche Abgabe in Köln-Ehrenfeld');
        this.setText('[data-confirmation-next]', handoverMethod === 'shipping'
          ? 'Wir prüfen deinen Verkaufsauftrag. Nach Bestätigung erhältst du dein kostenloses DHL-Versandlabel per E-Mail.'
          : 'Nach unserer Bestätigung kannst du dein Gerät bei iVoodoo, Ehrenfeldgürtel 148, 50823 Köln-Ehrenfeld abgeben.');
        this.querySelector('[data-confirmation-mail-warning]').hidden = data.emailQueued !== false;
        this.querySelector('.smartphone-buyback__layout').hidden = true;
        this.checkoutElement.hidden = true;
        this.querySelector('.ivoodoo-buyback-whatsapp-prompt').hidden = true;
        this.confirmationElement.hidden = false;
        this.confirmationElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        this.fokusAufUeberschrift(this.confirmationElement); // Paket B / F-050
      }

      // Paket B / F-050 (27.09.2026): unsichtbare Ansage-Region fuer Screenreader. Sie wird schon beim Start angelegt
      // (connectedCallback) - neu eingefuegte Regionen verpassen manche Screenreader (v. a. VoiceOver).
      ansageRegion() {
        if (!this.ansageElement) {
          this.ansageElement = document.createElement('p');
          this.ansageElement.className = 'visually-hidden';
          this.ansageElement.setAttribute('aria-live', 'polite');
          this.ansageElement.setAttribute('aria-atomic', 'true');
          (this.querySelector('.smartphone-buyback__summary-card') || this).appendChild(this.ansageElement);
        }
        return this.ansageElement;
      }

      ansagen(text) {
        const region = this.ansageRegion();
        region.textContent = '';
        window.setTimeout(() => { region.textContent = text; }, 150);
      }

      // Paket B / F-050 (Review 27.09.): Fokus auf "Weiter ..." nur, solange der Kunde nicht schon woanders ist
      // (Fokus auf der Seite oder noch auf dem - jetzt verborgenen - Angebotsknopf).
      fokusWeiter() {
        const aktiv = document.activeElement;
        if (aktiv && aktiv !== document.body && aktiv !== this.quoteButton) return;
        this.acceptButton.focus({ preventScroll: true });
      }

      // Paket B / F-050: nach dem Absenden Fokus auf die Ueberschrift der Bestaetigung (vorher fiel er auf die Seite).
      fokusAufUeberschrift(bereich) {
        const titel = bereich?.querySelector('h2, h3');
        if (!titel) return;
        titel.setAttribute('tabindex', '-1');
        titel.focus({ preventScroll: true });
      }

      startOver() {
        this.confirmationElement.hidden = true;
        this.querySelector('.smartphone-buyback__layout').hidden = false;
        this.querySelector('.ivoodoo-buyback-whatsapp-prompt').hidden = false;
        this.resetCheckoutState();
        this.selectionChanged();
        this.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      resetCategoryState() {
        this.closeModelList();
        this.selectedManufacturer = null;
        this.querySelectorAll('[data-manufacturer]').forEach(item => {
          item.classList.remove('is-selected');
          item.setAttribute('aria-pressed', 'false');
        });
        this.resetSelect(this.modelSelect);
        this.modelSelect.disabled = true;
        this.modelTrigger.disabled = true;
        this.renderModelOptions([]);
        this.resetSelect(this.storageSelect);
        this.storageSelect.disabled = true;
        this.querySelectorAll('[data-condition]').forEach(input => { input.checked = false; });
        this.querySelectorAll('[data-detail]').forEach(input => { input.checked = false; });
        this.setText('[data-summary-brand]', '—');
        this.setText('[data-summary-model]', '—');
        this.setText('[data-summary-storage]', '—');
        this.setText('[data-summary-condition]', '—');
        this.quoteButton.disabled = true;
        this.quoteButton.textContent = this.quoteButtonDefaultText;
        this.manualElement.hidden = true;
        this.layoutElement.hidden = false;
        this.mobileSummary.hidden = false;
        this.resetCheckoutState();
        this.updateMobileSummary();
        this.setStatus('');
      }

      setStatus(message, error = false, retry = null) {
        this.status.replaceChildren();
        this.status.classList.toggle('is-error', Boolean(error));
        if (!message) return;
        const body = document.createElement('span');
        body.className = 'iv-alert__body';
        body.textContent = message;
        this.status.appendChild(body);
        if (error && retry) {
          const actions = document.createElement('span');
          actions.className = 'iv-alert__actions';
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'iv-status-retry';
          button.textContent = 'Erneut versuchen';
          button.addEventListener('click', retry);
          actions.appendChild(button);
          this.status.appendChild(actions);
        }
      }

      // Block B (12.09.2026): Vor dem Kunden steht nie eine technische Meldung.
      // Fremdtext darf nur durch, wenn er ein kurzer Eingabehinweis ist (4xx, knapp,
      // ohne Klammern/JSON/englischen Jargon). Alles andere wird der hinterlegte Satz.
      humanError(error, fallback) {
        if (error) console.error('[iVoodoo Ankauf]', error);
        if (error && error.userText === true && error.message) return error.message;
        const text = String((error && error.serverMessage) || '').trim();
        const zeigbar = Boolean(error) && error.status >= 400 && error.status < 500 && text
          && text.length <= 160 && !/[<>{}]|DOCTYPE|JSON|token|undefined|Error|http/i.test(text);
        return zeigbar ? text : fallback;
      }

      // Haengt eine Anfrage, bleibt heute der Ladezustand endlos stehen. Nach 12 Sekunden
      // bricht sie ab und landet im vorhandenen Fehlerzweig - gleicher Satz, gleicher Weg.
      // Block H (12.09.2026): Das Limit laeuft, bis die Antwort gelesen ist - vorher endete es mit
      // dem Antwortkopf, und ein haengender Antwortkoerper hielt den Ladezustand endlos.
      async fetchJson(url, options = {}, timeoutMs = 12000) {
        const controller = new AbortController();
        const timer = window.setTimeout(() => controller.abort(), timeoutMs);
        try {
          const response = await fetch(url, { ...options, signal: controller.signal });
          const data = await this.readJson(response);
          return { ok: response.ok, status: response.status, json: () => Promise.resolve(data) };
        } finally {
          window.clearTimeout(timer);
        }
      }

      // Block H: Gelesen wird nur eine echte JSON-Antwort. Eine HTML-Seite (Stoerung am Proxy)
      // wird zum normalen Fehler mit Status statt zum SyntaxError - der Kunde sieht den Haussatz.
      async readJson(response) {
        const typ = response.headers.get('content-type') || '';
        if (!/json/i.test(typ)) {
          const fehler = new Error('keine JSON-Antwort (http ' + response.status + ')');
          fehler.status = response.status;
          throw fehler;
        }
        return response.json();
      }

      setText(selector, value) {
        const element = this.querySelector(selector);
        if (element) element.textContent = value;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
